import React, {
  useEffect,
  useState,
  useRef,
  useCallback,
  useMemo,
  useLayoutEffect,
} from "react";
import "./styles.css";
import { Button, Input, message, Popover, Drawer, Modal, Dropdown } from "antd";
import { fetchEventSource } from "../../utils/fetch-event-source";
import wx from "weixin-js-sdk";
import { normalizeMarkdownForRender } from "../../utils/markdownNormalize";
import { getEsHotelSearchHotels } from "../../utils/esHotelSearch";

import SwitchCloseIcon from "../../assets/switch-close.svg";
import SwitchOpenIcon from "../../assets/switch-open.svg";
import CreateNewChat from "../../assets/create-icon.png";
import MoreIcon from "../../assets/opreation-more.png";
import EditorIcon from "../../assets/editor.svg";
import DeleteIcon from "../../assets/delete.png";
import PhoneMenuIcon from "../../assets/phone-menu.png";
import PhoneReturnIcon from "../../assets/phone-return.png";
import PlayIcon from "../../assets/play-icon.png";
import ShareIcon from "../../assets/share-icon.png";
import LikeIcon from "../../assets/like-icon.svg";
import UnLikeIcon from "../../assets/unlike-icon.svg";
import RecordIcon from "../../assets/record-icon.png";
import CloseIcon from "../../assets/close-icon.png";
import ReferencesIcon from "../../assets/references-icon.png";
import LanguageIcon from "../../assets/language-icon.png";
import RecordingIcon from "../../assets/recording.gif";
import DownVoteActiveIcon from "../../assets/unlike-active-icon.svg";
import LikeActiveIcon from "../../assets/licke-active-icon.svg";
import PauseIcon from "../../assets/pause.png";
import { ReactComponent as CreateNewIcon } from "../../assets/create-new-icon.svg";
import { ReactComponent as LinkIcon } from "../../assets/link-icon.svg";
import { ReactComponent as CopyIcon } from "../../assets/copy-icon.svg";
import { ReactComponent as FreshIcon } from "../../assets/fresh-icon.svg";
import { ReactComponent as AddIconMobile } from "../../assets/add-phone.svg";
import { useTranslation } from "react-i18next";

import LanguageSwitcher from "../../components/LanguageSwitcher.jsx";
import AmapCard, { wgs84ToGcj02 } from "../../components/AmapCard/index.jsx";
import HotelCardList from "../../components/HotelCard/index.jsx";
import RouteCard from "../../components/RouteCard/index.jsx";
import ThinkingProcess from "../../components/ThinkingProcess/index.jsx";
import MarkdownContent from "../../components/MarkdownContent/index.jsx";
import mockMapData from "../../data/api.json";

const API_BASE_URL = "https://chinapedia-test.connectnowai.com";
const STT_WS_BASE_URL = "https://chinapedia-test.connectnowai.com";
const STT_SAMPLE_RATE = 16000;
const STT_SILENCE_TIMEOUT_MS = 3000;
const WS_LANG_MAP = {
  zh: "Chinese",
  en: "English",
  es: "Spanish",
  fr: "French",
  ru: "Russian",
  ar: "Arabic",
};
const getWsLangFromLocale = (locale) => {
  const key = String(locale || "en").split("-")[0];
  return WS_LANG_MAP[key] || key || "English";
};
const DEEP_THINKING_KEY = "chinapedia_deep_thinking";
const MARKDOWN_SSE_EVENT_NAMES = new Set([
  "itinerary_planning_sse",
  "tripai_sse",
]);
const TYPEWRITER_INTERVAL_MS = 24;
const TYPEWRITER_CHUNK_SIZE = {
  small: 5,
  medium: 12,
  large: 24,
  huge: 48,
};
const CHAT_RENDER_INITIAL_COUNT = 36;
const CHAT_RENDER_BATCH_COUNT = 18;
const CHAT_RENDER_TOP_THRESHOLD = 160;

const { TextArea } = Input;

let voiceText = "";

const SendIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xlink="http://www.w3.org/1999/xlink"
      fill="none"
      version="1.1"
      width="30"
      height="30"
      viewBox="0 0 30 30"
    >
      <defs>
        <clipPath id="master_svg0_31_10331">
          <rect x="0" y="0" width="30" height="30" rx="0" />
        </clipPath>
      </defs>
      <g clip-path="url(#master_svg0_31_10331)">
        <g>
          <path
            d="M3.75,16.249784765625L11.25,16.249784765625L11.25,13.749784765625L3.75,13.749784765625L3.75,2.306884765625C3.75,1.961709765625,4.029825,1.681884765625,4.375,1.681884765625C4.480312,1.681884765625,4.583925,1.708497365625,4.6762,1.759247265625L27.7542,14.452184765625C28.0567,14.618484765625,28.1671,14.998584765625,28.0007,15.301084765625C27.9436,15.404884765625,27.8581,15.490384765625,27.7542,15.547584765625L4.6762,28.240384765625C4.37375,28.406784765625,3.993712,28.296384765625,3.8273624,27.994084765625C3.7766126,27.901684765625,3.75,27.798184765625,3.75,27.692784765625L3.75,16.249784765625Z"
            fill="#FFFFFF"
            fillOpacity="1"
            style={{ mixBlendMode: "passthrough" }}
          />
        </g>
      </g>
    </svg>
  );
};
const SendIconSmall = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xlink="http://www.w3.org/1999/xlink"
      fill="none"
      version="1.1"
      width="16"
      height="16"
      viewBox="0 0 16 16"
    >
      <defs>
        <clipPath id="master_svg0_31_23267">
          <rect x="0" y="0" width="16" height="16" rx="0" />
        </clipPath>
      </defs>
      <g clip-path="url(#master_svg0_31_23267)">
        <g>
          <path
            d="M2,8.666522656249999L6,8.666522656249999L6,7.33318265625L2,7.33318265625L2,1.23030565625C2,1.04621265625,2.14924,0.89697265625,2.333333,0.89697265625C2.3895,0.89697265625,2.44476,0.91116605625,2.493973,0.93823265625L14.8023,7.70778265625C14.9636,7.79652265625,15.0225,7.99918265625,14.9337,8.16052265625C14.9033,8.215922656250001,14.8577,8.261522656250001,14.8023,8.29198265625L2.493973,15.06147265625C2.332667,15.15027265625,2.12998,15.09137265625,2.0412599,14.93007265625C2.0141934,14.88087265625,2,14.82567265625,2,14.76947265625L2,8.666522656249999Z"
            fill="#FFFFFF"
            fillOpacity="1"
            style={{ mixBlendMode: "passthrough" }}
          />
        </g>
      </g>
    </svg>
  );
};
const CustomerIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xlink="http://www.w3.org/1999/xlink"
      fill="none"
      version="1.1"
      width="50"
      height="50.000003814697266"
      viewBox="0 0 50 50.000003814697266"
    >
      <defs>
        <clipPath id="master_svg0_31_35016">
          <rect x="0" y="0" width="50" height="50.000003814697266" rx="0" />
        </clipPath>
      </defs>
      <g clip-path="url(#master_svg0_31_35016)">
        <g>
          <ellipse
            cx="24.375"
            cy="24.375"
            rx="19.375"
            ry="19.375"
            fill="#FFFFFF"
            fill-opacity="1"
          />
        </g>
        <g>
          <path
            d="M25,0C38.8,0,50,11.2,50,25C50,38.8,38.8,50,25,50C11.2,50,0,38.8,0,25C0,11.2,11.2,0,25,0ZM10.0583,33.5407C13.7271,39.0173,19.2378,42.5,25.3993,42.5C31.5607,42.5,37.0715,39.0173,40.7402,33.5407C36.7212,29.793,31.328,27.5,25.3993,27.5C19.4705,27.5,14.0774,29.793,10.0583,33.5407ZM25,22.5C29.1423,22.5,32.5,19.1421,32.5,15C32.5,10.8579,29.1423,7.5,25,7.5C20.8577,7.5,17.5,10.8579,17.5,15C17.5,19.1421,20.8577,22.5,25,22.5Z"
            fill="#919499"
            fill-opacity="1"
          />
        </g>
      </g>
    </svg>
  );
};
const CustomerIconMobile = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xlink="http://www.w3.org/1999/xlink"
      fill="none"
      version="1.1"
      width="40"
      height="40.000003814697266"
      viewBox="0 0 40 40.000003814697266"
    >
      <defs>
        <clipPath id="master_svg0_31_34986">
          <rect x="0" y="0" width="40" height="40.000003814697266" rx="0" />
        </clipPath>
      </defs>
      <g clip-path="url(#master_svg0_31_34986)">
        <g>
          <ellipse
            cx="19.5"
            cy="19.5"
            rx="15.5"
            ry="15.5"
            fill="#FFFFFF"
            fill-opacity="1"
          />
        </g>
        <g>
          <path
            d="M20,0C31.04,0,40,8.96,40,20C40,31.04,31.04,40,20,40C8.96,40,0,31.04,0,20C0,8.96,8.96,0,20,0ZM8.04664,26.8326C10.9817,31.2138,15.3902,34,20.3194,34C25.2486,34,29.6572,31.2138,32.5922,26.8326C29.377,23.8344,25.0624,22,20.3194,22C15.5764,22,11.2619,23.8344,8.04664,26.8326ZM20,18C23.3138,18,26,15.3137,26,12C26,8.6863,23.3138,6,20,6C16.6862,6,14,8.6863,14,12C14,15.3137,16.6862,18,20,18Z"
            fill="#919499"
            fill-opacity="1"
          />
        </g>
      </g>
    </svg>
  );
};
const AddIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xlink="http://www.w3.org/1999/xlink"
      fill="none"
      version="1.1"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <defs>
        <clipPath id="master_svg0_31_23287">
          <rect x="0" y="0" width="24" height="24" rx="0" />
        </clipPath>
      </defs>
      <g clip-path="url(#master_svg0_31_23287)">
        <g>
          <path
            d="M12,22C6.47715,22,2,17.5228,2,12C2,6.47715,6.47715,2,12,2C17.5228,2,22,6.47715,22,12C22,17.5228,17.5228,22,12,22ZM11,11L7,11L7,13L11,13L11,17L13,17L13,13L17,13L17,11L13,11L13,7L11,7L11,11Z"
            fill="#FFFFFF"
            fill-opacity="1"
          />
        </g>
      </g>
    </svg>
  );
};

const PC = () => {
  const { t, i18n } = useTranslation();
  useEffect(() => {
    // 获取微信JS-SDK配置
    const fetchWechatConfig = async () => {
      try {
        const response = await fetch(
          "https://wechat.cgtn.com/socialweb/social/weixin/getKeys.do?url=" +
            encodeURIComponent(window.location.href.split("#")[0]),
        );
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        console.log("获取微信配置成功:", data);
        // 初始化微信JS-SDK配置
        wx.config({
          debug: false, // 开启调试模式
          appId: "wxd61ff47456d31b8e",
          timestamp: data.data.timestamp,
          nonceStr: data.data.nonceStr,
          signature: data.data.signature,
          jsApiList: [
            "checkJsApi",
            "updateAppMessageShareData",
            "updateTimelineShareData",
          ],
        });

        // 处理配置成功
        wx.ready(() => {
          console.log("微信JS-SDK配置成功");
          const shareData = {
            title: "Chinapedia AI",
            desc: "Ask me anything about China!",
            link: window.location.href,
            imgUrl:
              "https://chinapedia.goclouds.cn/event/2025/Chinapedia-AI/logo.png",
            success: () => console.log("分享配置成功"),
            cancel: () => console.log("用户取消分享"),
          };

          // 检查JS API可用性
          wx.checkJsApi({
            jsApiList: ["updateAppMessageShareData", "updateTimelineShareData"],
            success: (res) => console.log("JS API检查结果:", res),
          });

          // 设置分享到朋友圈
          wx.updateTimelineShareData(shareData);

          // 设置分享给朋友
          wx.updateAppMessageShareData(shareData);
        });

        // 处理配置失败
        wx.error((err) => {
          console.error("微信JS-SDK配置失败:", err);
        });
      } catch (error) {
        console.error("获取微信配置失败:", error);
      }
    };

    // 执行配置获取
    fetchWechatConfig();
  }, []);

  // 初始化 browser_id（持久化）和 session_id（内存 ref，供位置上报与首次对话共用）
  useEffect(() => {
    try {
      let bid = localStorage.getItem("browser_id");
      if (!bid) {
        bid = generateWsSessionId();
        localStorage.setItem("browser_id", bid);
      }
      browserIdRef.current = bid;
    } catch (_) {
      browserIdRef.current = generateWsSessionId();
    }
    if (!wsSessionIdRef.current) {
      wsSessionIdRef.current = generateWsSessionId();
    }
  }, []);

  useEffect(() => {
    if (!navigator.geolocation) return;
    // StrictMode 下 effect 会执行两次，加 ref 幂等保护，避免 /location/save 被重复请求
    if (locationRequestedRef.current) return;
    locationRequestedRef.current = true;

    navigator.geolocation.getCurrentPosition(
      (pos) => {
        const { longitude, latitude, accuracy } = pos.coords;
        const converted = wgs84ToGcj02(longitude, latitude);
        if (!converted) {
          console.warn("[location] convert failed, use raw coords");
        }
        const finalLng = converted?.lng ?? longitude;
        const finalLat = converted?.lat ?? latitude;
        const loc = `${finalLng},${finalLat}`;
        setUserLocation(loc);
        console.log("[location] user location:", loc);

        const body = {
          browser_id: browserIdRef.current,
          session_id: wsSessionIdRef.current,
          location: {
            lng: finalLng,
            lat: finalLat,
            accuracy: Math.round(accuracy ?? 0),
          },
        };
        fetch(`${API_BASE_URL}/location/save`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(body),
        })
          .then((res) => res.json().catch(() => ({})))
          .then((data) => console.log("[location] save resp:", data))
          .catch((err) =>
            console.warn("[location] save failed:", err?.message || err),
          );
      },
      (err) => {
        console.warn("[location] denied or failed:", err.message);
      },
      { enableHighAccuracy: true, timeout: 8000, maximumAge: 300000 },
    );
  }, []);

  const controllerRef = useRef(null);
  const controllerRef1 = useRef(null);
  const chatDivRef = useRef(null);
  const shouldSmoothScrollRef = useRef(false);
  const wsRef = useRef(null);
  const wsSessionIdRef = useRef("");
  const browserIdRef = useRef("");
  const locationRequestedRef = useRef(false);
  const pendingMessagesRef = useRef([]);
  const wsReconnectTimerRef = useRef(null);
  const wsPingTimerRef = useRef(null);
  const wsReconnectAttemptsRef = useRef(0);
  const wsConnectingSessionIdRef = useRef("");
  const wsConnectingLangRef = useRef("");
  const wsConnectionLangRef = useRef("");
  const currentMsgIdRef_ws = useRef(null);
  const wsTtsMsgIdRef = useRef("");
  const wsTtsLocalMsgIdRef = useRef("");
  const wsTtsMsgIdMapRef = useRef(new Map());
  const wsTtsSeenSeqRef = useRef(new Set());
  const wsTtsSeenUrlRef = useRef(new Set());
  const blockedTtsPlaybackIdsRef = useRef(new Set());
  const pendingMapCardsRef = useRef([]);
  const pendingRouteCardsRef = useRef([]);
  const pendingHotelDataRef = useRef([]);
  const hotelStreamBufferRef = useRef("");
  const hotelStreamTextBufferRef = useRef("");
  const typewriterQueueRef = useRef(new Map());
  const typewriterTimerRef = useRef(new Map());
  const typewriterTargetContentRef = useRef(new Map());
  const sttWsRef = useRef(null);
  const sttAudioContextRef = useRef(null);
  const sttMediaStreamRef = useRef(null);
  const sttSourceRef = useRef(null);
  const sttProcessorRef = useRef(null);
  const sttSilenceTimerRef = useRef(null);
  const sttInputBaseRef = useRef("");
  const historyLoadTimerRef = useRef(null);
  const historyLoadReqIdRef = useRef(0);
  const tipList = [
    {
      id: 1,
      title: t("tip.culture"),
      content: t("tip.culture.content"),
    },
    {
      id: 2,
      title: t("tip.travel"),
      content: t("tip.travel.content"),
    },
    {
      id: 3,
      title: t("tip.technology"),
      content: t("tip.technology.content"),
    },
    {
      id: 4,
      title: t("tip.nature"),
      content: t("tip.nature.content"),
    },
    {
      id: 5,
      title: t("tip.economy"),
      content: t("tip.economy.content"),
    },
    {
      id: 6,
      title: t("tip.history"),
      content: t("tip.history.content"),
    },
  ];
  const [userLocation, setUserLocation] = useState(null);
  const [inputValue, setInputValue] = useState("");
  const [chatHistory, setChatHistory] = useState([]);
  const chatHistoryRef = useRef([]);
  const [renderedMessageCount, setRenderedMessageCount] = useState(
    CHAT_RENDER_INITIAL_COUNT,
  );
  const pendingHistoryPrependRef = useRef(null);
  const [isLoading, setIsLoading] = useState(false);
  const [openSwitch, setOpenSwitch] = useState(false); //是否展开侧边栏
  const [editorStatus, setEditorStatus] = useState(false); //是否编辑历史问题名称
  const [drawerOpen, setDrawerOpen] = useState(false); //是否展开移动端侧边栏
  const [isLongPress, setIsLongPress] = useState(false);
  const [showBubblePhone, setShowBubblePhone] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false); //移动端重命名弹窗
  const [shareModalOpenPhone, setShareModalOpenPhone] = useState(false); //移动端分享弹窗
  const [shareAgentData, setShareAgentData] = useState([]); //当前分享的数据
  const [editorValue, setEditorValue] = useState(""); //当前修改问题值
  const [chatIdSelect, setChatIdSelect] = useState(""); //当前对话的ID
  const [nameValue, setNameValue] = useState(""); //重命名回显值
  const [nameValueData, setNameValueData] = useState(null); //重命名数据
  const [historyList, setHistoryList] = useState([]); //当前页面聊天历史记录
  const [isHistoryLoading, setIsHistoryLoading] = useState(false);
  const firstHandled = useRef(false); // 标记是否已经处理过第一次消息
  const [currentPlaying, setCurrentPlaying] = useState(null); // 当前播放的 audioUrl
  const audioRef = useRef(null);
  const [langText, setLangText] = useState(null); // 当前语言
  const [defaultSelectedKeys, setDefaultSelectedKeys] = useState(null); // 当前语言
  const languageTextMap = {
    en: "English",
    zh: "中文",
    ar: "العربية",
    es: "Español",
    fr: "Français",
    ru: "Русский",
  };
  const items = [
    {
      key: "1",
      label: "中文",
    },
    {
      key: "2",
      label: "English",
    },
    {
      key: "3",
      label: "Español",
    },
    {
      key: "4",
      label: "Français",
    },
    {
      key: "5",
      label: "Русский",
    },
    {
      key: "6",
      label: "العربية",
    },
  ];
  const current = (
    localStorage.getItem("language") ||
    i18n.resolvedLanguage ||
    i18n.language ||
    "en"
  ).split("-")[0];

  // 录音转文字
  const [inputText, setInputText] = useState("");
  // 是否在录音
  const [isListening, setIsListening] = useState(false);
  // 是否是移动端
  const [isMobile, setIsMobile] = useState(true);
  const [deleteModal, setDeleteModal] = useState(false); //删除会话提示
  const [deleteData, setDeleteData] = useState(null); //删除会话提示
  const [openPopoverId, setOpenPopoverId] = useState(null);
  const [pauseChatStatus, setPauseChatStatus] = useState(false); //是否暂停会话
  const inputRef = useRef(null); // 引用输入框
  const [isComposing, setIsComposing] = useState(false); // 是否处于中文输入中
  const [deepThinking, setDeepThinking] = useState(() => {
    try {
      return localStorage.getItem(DEEP_THINKING_KEY) === "true";
    } catch {
      return false;
    }
  });
  const [isThinking, setIsThinking] = useState(false);
  const [showThinking, setShowThinking] = useState(false);
  const [thinkingSteps, setThinkingSteps] = useState([]);
  const thinkingStepsRef = useRef([]);
  useEffect(() => {
    thinkingStepsRef.current = thinkingSteps;
  }, [thinkingSteps]);

  useEffect(() => {
    chatHistoryRef.current = chatHistory;
  }, [chatHistory]);

  useEffect(() => {
    setRenderedMessageCount((prev) => {
      if (chatHistory.length <= CHAT_RENDER_INITIAL_COUNT) {
        return CHAT_RENDER_INITIAL_COUNT;
      }
      return Math.min(
        Math.max(prev, CHAT_RENDER_INITIAL_COUNT),
        chatHistory.length,
      );
    });
  }, [chatHistory.length]);

  const visibleChatHistory = useMemo(() => {
    const startIndex = Math.max(0, chatHistory.length - renderedMessageCount);
    return chatHistory.slice(startIndex).map((item, index) => ({
      item,
      index: startIndex + index,
    }));
  }, [chatHistory, renderedMessageCount]);

  const handleChatScroll = useCallback((event) => {
    const target = event.currentTarget;
    if (!target || target.scrollTop > CHAT_RENDER_TOP_THRESHOLD) return;

    setRenderedMessageCount((prev) => {
      if (prev >= chatHistoryRef.current.length) return prev;
      pendingHistoryPrependRef.current = {
        scrollHeight: target.scrollHeight,
        scrollTop: target.scrollTop,
      };
      return Math.min(
        prev + CHAT_RENDER_BATCH_COUNT,
        chatHistoryRef.current.length,
      );
    });
  }, []);

  useLayoutEffect(() => {
    const pending = pendingHistoryPrependRef.current;
    if (!pending || !chatDivRef.current) return;

    const nextScrollTop =
      chatDivRef.current.scrollHeight -
      pending.scrollHeight +
      pending.scrollTop;
    chatDivRef.current.scrollTop = nextScrollTop;
    pendingHistoryPrependRef.current = null;
  }, [renderedMessageCount]);

  useEffect(() => {
    // 监听语言切换
    const handleLanguageChange = (lng) => {
      // 页面始终保持 LTR，不因阿拉伯语变 RTL
      document.documentElement.setAttribute("dir", "ltr");
      document.documentElement.setAttribute("lang", lng);
    };
    // 立即执行一次，保证初始加载时也正确
    handleLanguageChange(
      (
        localStorage.getItem("language") ||
        i18n.resolvedLanguage ||
        i18n.language ||
        "en"
      ).split("-")[0],
    );

    // 监听 i18n 语言变化事件
    i18n.on("languageChanged", handleLanguageChange);
    // 清理监听器
    return () => {
      i18n.off("languageChanged", handleLanguageChange);
    };
  }, []);
  // 将 base64 转换成 Blob URL
  const base64ToBlobUrl = (base64Data, mimeType = "audio/wav") => {
    // 如果包含 data:audio/xxx;base64, 头部，先去掉
    let cleaned = base64Data;
    if (base64Data.includes(",")) {
      cleaned = base64Data.split(",")[1];
    }

    // 清理可能存在的换行符或空格
    cleaned = cleaned.replace(/\s/g, "");

    // 解码 base64 -> 二进制
    const byteString = atob(cleaned);
    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);
    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }

    const blob = new Blob([ia], { type: mimeType });
    return URL.createObjectURL(blob);
  };

  const getPlayableAudioUrl = (audioData) => {
    if (/^(https?:|blob:|data:audio)/.test(audioData)) {
      return audioData;
    }
    return base64ToBlobUrl(audioData, "audio/mp3");
  };

  const useAudioQueue = (onQueueEnd) => {
    const audioQueueRef = useRef([]); // [{ url, msgId }]
    const currentAudioRef = useRef(null);
    const currentMsgIdRef = useRef(null); // 新增：当前播放的 msgId
    const isAudioEnabledRef = useRef(true); // ✅ 是否允许接收播放新音频

    // 播放队列
    const playNext = async () => {
      if (!isAudioEnabledRef.current) {
        audioQueueRef.current = [];
        currentMsgIdRef.current = null;
        return;
      }
      if (audioQueueRef.current.length === 0) {
        currentMsgIdRef.current = null; // 队列为空时清空当前 msgId
        return;
      }

      const { url, msgId } = audioQueueRef.current.shift();
      const audio = new Audio(url);
      currentAudioRef.current = audio;
      currentMsgIdRef.current = msgId; // 设置当前播放的 msgId

      audio.onended = () => {
        currentAudioRef.current = null;

        if (audioQueueRef.current.length === 0) {
          // 队列空了 → 通知外部对应 msgId 的播放完成
          if (onQueueEnd) onQueueEnd(msgId);
          currentMsgIdRef.current = null; // 清空当前 msgId
        }

        if (isAudioEnabledRef.current) {
          playNext(); // 继续下一条
        }
      };

      try {
        await audio.play();
      } catch (err) {
        console.error("音频播放失败:", err);
        if (isAudioEnabledRef.current) {
          playNext(); // 播放失败时继续下一个
        }
      }
    };

    // 添加音频到队列（带 msgId）
    const enqueueAudio = (url, msgId) => {
      if (!isAudioEnabledRef.current) return; // ✅ 如果暂停播放，不接收新音频
      audioQueueRef.current.push({ url, msgId });

      if (!currentAudioRef.current) {
        playNext();
      }
    };

    const pause = () => {
      if (currentAudioRef.current) {
        currentAudioRef.current.pause();
      }
      isAudioEnabledRef.current = false; // ✅ 停止接收新音频
    };

    const stop = () => {
      if (currentAudioRef.current) {
        currentAudioRef.current.pause();
        currentAudioRef.current = null;
      }
      audioQueueRef.current = [];
      currentMsgIdRef.current = null; // 清空当前 msgId
      isAudioEnabledRef.current = false; // ✅ 暂停接收新音频
    };

    const resume = () => {
      isAudioEnabledRef.current = true; // ✅ 允许继续接收
      // if (!currentAudioRef.current && audioQueueRef.current.length > 0) {
      //   playNext();
      // }
    };

    // 新增：获取当前播放的 msgId
    const getCurrentMsgId = () => {
      return currentMsgIdRef.current;
    };

    // 新增：检查是否正在播放指定 msgId
    const isPlayingMsgId = (msgId) => {
      return currentMsgIdRef.current === msgId;
    };

    return {
      enqueueAudio,
      pause,
      stop,
      getCurrentMsgId,
      isPlayingMsgId,
      resume,
    };
  };

  const {
    enqueueAudio,
    stop: stopTTS,
    getCurrentMsgId,
    isPlayingMsgId,
    resume: resumeTTS,
  } = useAudioQueue((finishedMsgId) => {
    // 队列播放完成 → 把对应消息 isPlaying 改为 false
    setChatHistory((prev) => {
      const newHistory = [...prev];
      const index = newHistory.findIndex(
        (item) => item.msgId === finishedMsgId,
      );
      if (index !== -1) {
        newHistory[index] = {
          ...newHistory[index],
          isPlaying: false,
        };
      }
      return newHistory;
    });
  });

  const getTtsPlaybackIds = (itemData, includeActiveTts = true) => {
    return [
      itemData?.msgId,
      itemData?.messageId,
      includeActiveTts ? wsTtsMsgIdRef.current : "",
      includeActiveTts ? wsTtsLocalMsgIdRef.current : "",
      includeActiveTts
        ? wsTtsMsgIdMapRef.current.get(wsTtsMsgIdRef.current)
        : "",
    ]
      .filter(Boolean)
      .map(String);
  };

  const blockTtsPlayback = (itemData) => {
    getTtsPlaybackIds(itemData).forEach((id) => {
      blockedTtsPlaybackIdsRef.current.add(id);
    });
  };

  const allowTtsPlayback = (itemData) => {
    const ids = itemData ? getTtsPlaybackIds(itemData, false) : [];
    if (itemData) {
      const itemIds = new Set(ids);
      wsTtsMsgIdMapRef.current.forEach((localMsgId, backendMsgId) => {
        if (
          itemIds.has(String(localMsgId)) ||
          itemIds.has(String(backendMsgId))
        ) {
          ids.push(localMsgId, backendMsgId);
        }
      });
      if (
        itemIds.has(String(wsTtsLocalMsgIdRef.current)) ||
        itemIds.has(String(wsTtsMsgIdMapRef.current.get(wsTtsMsgIdRef.current)))
      ) {
        ids.push(wsTtsMsgIdRef.current);
      }
    }
    if (ids.length === 0) {
      blockedTtsPlaybackIdsRef.current = new Set();
      return;
    }
    ids.forEach((id) => {
      blockedTtsPlaybackIdsRef.current.delete(id);
    });
  };

  const isTtsPlaybackBlocked = (ids) => {
    return ids
      .filter(Boolean)
      .map(String)
      .some((id) => blockedTtsPlaybackIdsRef.current.has(id));
  };

  const blockPriorSystemTts = (history = []) => {
    const staleBackendIds = [];
    wsTtsMsgIdMapRef.current.forEach((localMsgId, backendMsgId) => {
      staleBackendIds.push(String(backendMsgId), String(localMsgId));
    });
    if (wsTtsMsgIdRef.current) staleBackendIds.push(String(wsTtsMsgIdRef.current));
    if (wsTtsLocalMsgIdRef.current) {
      staleBackendIds.push(String(wsTtsLocalMsgIdRef.current));
    }
    history.forEach((item) => {
      if (item.role === "system") blockTtsPlayback(item);
    });
    staleBackendIds.forEach((id) => {
      blockedTtsPlaybackIdsRef.current.add(id);
    });
  };

  const scrollChatToBottom = (delay = 0) => {
    const scroll = () => {
      let chatDiv = document.querySelector(".ChatDiv");
      if (chatDiv) chatDiv.scrollTop = chatDiv.scrollHeight;
    };

    if (delay > 0) {
      setTimeout(scroll, delay);
      return;
    }
    scroll();
  };

  const getTypewriterStepSize = (queueLength) => {
    if (queueLength > 1200) return TYPEWRITER_CHUNK_SIZE.huge;
    if (queueLength > 500) return TYPEWRITER_CHUNK_SIZE.large;
    if (queueLength > 160) return TYPEWRITER_CHUNK_SIZE.medium;
    return TYPEWRITER_CHUNK_SIZE.small;
  };

  const clearTypewriterTimer = (msgId) => {
    const timer = typewriterTimerRef.current.get(msgId);
    if (timer) clearTimeout(timer);
    typewriterTimerRef.current.delete(msgId);
  };

  const flushTypewriterQueue = (msgId) => {
    const pending = typewriterQueueRef.current.get(msgId) || "";
    if (!pending) return;

    clearTypewriterTimer(msgId);
    typewriterQueueRef.current.set(msgId, "");
    setChatHistory((prev) => {
      const index = prev.findIndex((item) => item.msgId === msgId);
      if (index === -1) return prev;
      const newHistory = [...prev];
      const prevItem = newHistory[index];
      const targetContent =
        typewriterTargetContentRef.current.get(msgId) ||
        `${prevItem.content || ""}${pending}`;
      newHistory[index] = {
        ...prevItem,
        content: targetContent,
      };
      return newHistory;
    });
    scrollChatToBottom(0);
  };

  const cleanupTypewriter = (msgId) => {
    if (!msgId) return;
    clearTypewriterTimer(msgId);
    typewriterQueueRef.current.delete(msgId);
    typewriterTargetContentRef.current.delete(msgId);
  };

  const flushAllTypewriterQueues = () => {
    const msgIds = new Set([
      ...typewriterQueueRef.current.keys(),
      ...typewriterTargetContentRef.current.keys(),
    ]);
    msgIds.forEach((msgId) => flushTypewriterQueue(msgId));
  };

  const cleanupAllTypewriters = ({ flush = false } = {}) => {
    if (flush) flushAllTypewriterQueues();

    typewriterTimerRef.current.forEach((timer) => clearTimeout(timer));
    typewriterTimerRef.current = new Map();
    typewriterQueueRef.current = new Map();
    typewriterTargetContentRef.current = new Map();
  };

  const scheduleTypewriterFlush = (msgId) => {
    if (typewriterTimerRef.current.has(msgId)) return;

    const timer = setTimeout(() => {
      typewriterTimerRef.current.delete(msgId);

      const pending = typewriterQueueRef.current.get(msgId) || "";
      if (!pending) return;

      const stepSize = getTypewriterStepSize(pending.length);
      const nextText = pending.slice(0, stepSize);
      const restText = pending.slice(stepSize);
      typewriterQueueRef.current.set(msgId, restText);

      setChatHistory((prev) => {
        const index = prev.findIndex((item) => item.msgId === msgId);
        if (index === -1) return prev;
        const newHistory = [...prev];
        const prevItem = newHistory[index];
        newHistory[index] = {
          ...prevItem,
          content: `${prevItem.content || ""}${nextText}`,
        };
        return newHistory;
      });
      scrollChatToBottom(0);

      if (restText) {
        scheduleTypewriterFlush(msgId);
      } else if (currentMsgIdRef_ws.current !== msgId) {
        cleanupTypewriter(msgId);
      }
    }, TYPEWRITER_INTERVAL_MS);

    typewriterTimerRef.current.set(msgId, timer);
  };

  const appendTypewriterContent = (msgId, text = "") => {
    if (!msgId || !text) return;

    const targetContent =
      (typewriterTargetContentRef.current.get(msgId) ||
        chatHistoryRef.current.find((item) => item.msgId === msgId)?.content ||
        "") + text;
    typewriterTargetContentRef.current.set(msgId, targetContent);
    typewriterQueueRef.current.set(
      msgId,
      `${typewriterQueueRef.current.get(msgId) || ""}${text}`,
    );
    scheduleTypewriterFlush(msgId);
  };

  const appendMarkdownTypewriterContent = (msgId, text = "") => {
    if (!msgId || !text) return;

    const prevContent =
      typewriterTargetContentRef.current.get(msgId) ||
      chatHistoryRef.current.find((item) => item.msgId === msgId)?.content ||
      "";
    const normalizedChunk = normalizeItineraryMarkdownChunk(prevContent, text);
    appendTypewriterContent(msgId, normalizedChunk);
  };

  const wsHandlersRef = useRef({});
  wsHandlersRef.current = {
    setChatHistory,
    setIsLoading,
    resumeTTS,
    setIsThinking,
    setShowThinking,
    setThinkingSteps,
  };

  const generateWsSessionId = () => {
    try {
      if (window.crypto && typeof window.crypto.randomUUID === "function") {
        return window.crypto.randomUUID();
      }
    } catch {
      /* ignore */
    }
    const s4 = () =>
      Math.floor((1 + Math.random()) * 0x10000)
        .toString(16)
        .substring(1);
    return `${s4()}${s4()}-${s4()}-${s4()}-${s4()}-${s4()}${s4()}${s4()}`;
  };

  const getCurrentWsLang = useCallback(() => {
    const locale =
      localStorage.getItem("language") ||
      i18n.resolvedLanguage ||
      i18n.language ||
      "en";
    return getWsLangFromLocale(locale);
  }, [i18n.resolvedLanguage, i18n.language]);

  const getOrCreateBrowserId = useCallback(() => {
    if (browserIdRef.current) return browserIdRef.current;
    try {
      let bid = localStorage.getItem("browser_id");
      if (!bid) {
        bid = generateWsSessionId();
        localStorage.setItem("browser_id", bid);
      }
      browserIdRef.current = bid;
      return bid;
    } catch (_) {
      const fallbackBid = generateWsSessionId();
      browserIdRef.current = fallbackBid;
      return fallbackBid;
    }
  }, []);

  const fetchPresignedWsUrl = useCallback(
    async (sessionId, lang = getCurrentWsLang()) => {
      const params = new URLSearchParams({
        session_id: sessionId,
        browser_id: getOrCreateBrowserId(),
        lang,
      });
      const resp = await fetch(
        `${API_BASE_URL}/websocket/presigned-url?${params.toString()}`,
      );
      if (!resp.ok) {
        throw new Error(`HTTP ${resp.status}`);
      }
      const json = await resp.json();
      const wsUrl = json?.data?.url;
      if (!wsUrl) {
        throw new Error("Missing data.url from presigned-url response");
      }
      return wsUrl;
    },
    [getCurrentWsLang, getOrCreateBrowserId],
  );

  const syncCurrentWsMessageId = useCallback((metadata) => {
    const backendMessageId = metadata?.message_id
      ? String(metadata.message_id)
      : "";
    const localMsgId = currentMsgIdRef_ws.current;
    if (!backendMessageId || !localMsgId) return "";

    wsTtsMsgIdMapRef.current.set(backendMessageId, localMsgId);
    setChatHistory((prev) => {
      const index = prev.findIndex(
        (item) =>
          item.msgId === localMsgId || item.messageId === backendMessageId,
      );
      if (index === -1 || prev[index].messageId === backendMessageId) {
        return prev;
      }

      const newHistory = [...prev];
      newHistory[index] = {
        ...newHistory[index],
        messageId: backendMessageId,
      };
      return newHistory;
    });

    return backendMessageId;
  }, []);

  const cleanupWebSocket = useCallback(() => {
    if (wsPingTimerRef.current) {
      clearInterval(wsPingTimerRef.current);
      wsPingTimerRef.current = null;
    }
    if (wsReconnectTimerRef.current) {
      clearTimeout(wsReconnectTimerRef.current);
      wsReconnectTimerRef.current = null;
    }
    wsConnectingSessionIdRef.current = "";
    wsConnectingLangRef.current = "";
    wsConnectionLangRef.current = "";
    if (wsRef.current) {
      wsRef.current.onopen = null;
      wsRef.current.onmessage = null;
      wsRef.current.onerror = null;
      wsRef.current.onclose = null;
      if (
        wsRef.current.readyState === WebSocket.OPEN ||
        wsRef.current.readyState === WebSocket.CONNECTING
      ) {
        wsRef.current.close();
      }
      wsRef.current = null;
    }
  }, []);

  const connectWebSocket = useCallback(
    async (sessionId, options = {}) => {
      if (!sessionId) return;
      const { force = false, lang } = options;
      const wsLang = lang || getCurrentWsLang();

      if (
        !force &&
        (wsRef.current?.readyState === WebSocket.OPEN ||
          wsRef.current?.readyState === WebSocket.CONNECTING) &&
        wsSessionIdRef.current === sessionId &&
        wsConnectionLangRef.current === wsLang
      ) {
        return;
      }
      if (
        !force &&
        wsConnectingSessionIdRef.current === sessionId &&
        wsConnectingLangRef.current === wsLang
      ) {
        return;
      }

      cleanupWebSocket();
      wsConnectingSessionIdRef.current = sessionId;
      wsConnectingLangRef.current = wsLang;
      wsSessionIdRef.current = sessionId;

      let wsUrl = "";
      try {
        wsUrl = await fetchPresignedWsUrl(sessionId, wsLang);
      } catch (err) {
        if (
          wsConnectingSessionIdRef.current === sessionId &&
          wsConnectingLangRef.current === wsLang
        ) {
          wsConnectingSessionIdRef.current = "";
          wsConnectingLangRef.current = "";
        }
        console.error("Failed to get presigned websocket url:", err);
        if (wsReconnectAttemptsRef.current < 5) {
          wsReconnectAttemptsRef.current++;
          const delay = Math.min(
            1000 * Math.pow(2, wsReconnectAttemptsRef.current),
            30000,
          );
          wsReconnectTimerRef.current = setTimeout(() => {
            connectWebSocket(wsSessionIdRef.current);
          }, delay);
        }
        return;
      }
      if (
        wsSessionIdRef.current !== sessionId ||
        wsConnectingLangRef.current !== wsLang
      ) {
        return;
      }
      console.log("WebSocket connecting:", wsUrl);
      //暂时先不用agentcore有问题
      // const ws = new WebSocket(wsUrl);
      // 测试用ws地址;
      const testWsParams = new URLSearchParams({
        session_id: sessionId,
        browser_id: getOrCreateBrowserId(),
        lang: wsLang,
      });
      const ws = new WebSocket(
        `wss://chinapedia-test.connectnowai.com/ws?${testWsParams.toString()}`,
      );
      wsRef.current = ws;
      wsConnectionLangRef.current = wsLang;

      const connectionTimeout = setTimeout(() => {
        if (ws.readyState !== WebSocket.OPEN) {
          console.error("WebSocket connection timeout");
          ws.close();
        }
      }, 10000);

      ws.onopen = () => {
        wsConnectingSessionIdRef.current = "";
        wsConnectingLangRef.current = "";
        clearTimeout(connectionTimeout);
        console.log("WebSocket connected, session:", sessionId);
        wsReconnectAttemptsRef.current = 0;

        if (pendingMessagesRef.current.length > 0) {
          const messages = [...pendingMessagesRef.current];
          pendingMessagesRef.current = [];
          messages.forEach((content) => {
            const msg = {
              type: "text",
              content,
              session_id: sessionId,
              metadata: { message_id: String(Date.now()) },
            };
            ws.send(JSON.stringify(msg));
          });
        }

        wsPingTimerRef.current = setInterval(() => {
          if (ws.readyState === WebSocket.OPEN) {
            ws.send(JSON.stringify({ type: "ping" }));
          }
        }, 30000);
      };

      ws.onmessage = (event) => {
        let data;
        try {
          data = JSON.parse(event.data);
        } catch {
          return;
        }

        const { type } = data;

        if (type === "pong") return;
        const wsMessageId = syncCurrentWsMessageId(data?.metadata);

        if (type === "text" && !currentMsgIdRef_ws.current) {
          return;
        }

        if (type === "status" || type === "agent_status") {
          if (!currentMsgIdRef_ws.current) return;
          const statusContent = data.content || "";
          wsHandlersRef.current.setShowThinking(true);
          wsHandlersRef.current.setIsThinking(true);
          wsHandlersRef.current.setThinkingSteps((prev) => {
            if (prev[prev.length - 1] === statusContent) return prev;
            return [...prev, statusContent];
          });
          if (statusContent === "Start Translate") {
            const msgId = currentMsgIdRef_ws.current;
            if (msgId) {
              wsHandlersRef.current.setChatHistory((prev) => {
                const index = prev.findIndex((item) => item.msgId === msgId);
                if (index === -1) return prev;
                const newHistory = [...prev];
                newHistory[index] = {
                  ...newHistory[index],
                  content: newHistory[index].content + "\n\n",
                };
                return newHistory;
              });
            }
          }
          return;
        }

        if (type === "stream_start") {
          if (!currentMsgIdRef_ws.current) return;
          resumeTTS();
          return;
        }

        if (type === "stream_chunk") {
          const chunkText = data.content || "";
          if (!chunkText) return;

          const msgId = currentMsgIdRef_ws.current;
          if (!msgId) return;

          wsHandlersRef.current.setIsThinking(false);
          scrollChatToBottom(0);
          appendTypewriterContent(msgId, chunkText);
          return;
        }

        if (type === "stream_end") {
          const msgId = currentMsgIdRef_ws.current;
          const metadataMessageId =
            wsMessageId ||
            (data?.metadata?.message_id
              ? String(data.metadata.message_id)
              : "");
          const docDetails = formatDocDetails(data?.metadata?.doc_detail);
          const hasMapCards = pendingMapCardsRef.current.length > 0;
          const hasHotelData = pendingHotelDataRef.current.length > 0;
          const hasRouteCards = pendingRouteCardsRef.current.length > 0;
          const cards = [...pendingMapCardsRef.current];
          const hotels = [...pendingHotelDataRef.current];
          const routes = [...pendingRouteCardsRef.current];

          pendingMapCardsRef.current = [];
          pendingHotelDataRef.current = [];
          pendingRouteCardsRef.current = [];

          if (msgId) {
            setChatHistory((prev) => {
              const index = prev.findIndex((item) => item.msgId === msgId);
              if (index === -1) return prev;
              const newHistory = [...prev];
              const prevItem = newHistory[index];
              const updates = { isFinished: true };
              if (metadataMessageId) {
                updates.messageId = String(metadataMessageId);
                wsTtsMsgIdMapRef.current.set(String(metadataMessageId), msgId);
              }
              if (docDetails.length > 0) {
                updates.documents = docDetails;
              }
              if (hasMapCards) {
                const existingCards = prevItem.mapCards || [];
                updates.mapCards = [...existingCards, ...cards];
              }
              if (hasHotelData) {
                const existingHotels = prevItem.hotelCards || [];
                updates.hotelCards = [...existingHotels, ...hotels];
              }
              if (hasRouteCards) {
                const existingRoutes = prevItem.routeCards || [];
                updates.routeCards = [...existingRoutes, ...routes];
              }
              newHistory[index] = { ...prevItem, ...updates };
              return newHistory;
            });
            scrollChatToBottom(100);
          }

          const stepsSnap = thinkingStepsRef.current;
          if (msgId && stepsSnap.length > 0) {
            wsHandlersRef.current.setChatHistory((prev) => {
              const idx = prev.findIndex((i) => i.msgId === msgId);
              if (idx === -1) return prev;
              const nh = [...prev];
              nh[idx] = { ...nh[idx], thinkingSteps: [...stepsSnap] };
              return nh;
            });
          }
          wsHandlersRef.current.setShowThinking(false);
          wsHandlersRef.current.setIsThinking(false);
          wsHandlersRef.current.setThinkingSteps([]);

          setIsLoading(false);
          if (
            msgId &&
            !isTtsPlaybackBlocked([
              msgId,
              wsTtsMsgIdRef.current,
              wsTtsLocalMsgIdRef.current,
            ])
          ) {
            resumeTTS();
          }
          currentMsgIdRef_ws.current = null;
          if (msgId && !typewriterQueueRef.current.get(msgId)) {
            cleanupTypewriter(msgId);
          }
          return;
        }

        if (type === "structured") {
          const name = data.content?.name;
          const payload = data.content?.payload;
          const esHotelCards = getEsHotelSearchHotels(name, payload);

          if (esHotelCards.length > 0) {
            const msgId = currentMsgIdRef_ws.current;
            if (!msgId) return;

            setChatHistory((prev) =>
              prev.map((item) =>
                item.msgId === msgId
                  ? {
                      ...item,
                      hotelCards: [
                        ...(item.hotelCards || []),
                        ...esHotelCards,
                      ],
                    }
                  : item,
              ),
            );
            scrollChatToBottom(100);
            return;
          }

          if (name === "tts_audio_chunk") {
            const pType = payload?.type;
            const backendMsgId = String(payload?.msg_id || "");
            const audioData = payload?.audio_base64 || "";
            if (pType !== "chunk" || !backendMsgId || !audioData) return;

            const activeMsgId = currentMsgIdRef_ws.current;
            if (!activeMsgId) return;

            const currentTtsMsgId = wsTtsMsgIdRef.current;
            if (!currentTtsMsgId) {
              wsTtsMsgIdRef.current = backendMsgId;
              wsTtsLocalMsgIdRef.current = activeMsgId;
              if (wsTtsLocalMsgIdRef.current) {
                wsTtsMsgIdMapRef.current.set(
                  backendMsgId,
                  wsTtsLocalMsgIdRef.current,
                );
              }
              wsTtsSeenSeqRef.current = new Set();
              wsTtsSeenUrlRef.current = new Set();
            } else if (currentTtsMsgId !== backendMsgId) {
              const prevNum = Number(currentTtsMsgId);
              const nextNum = Number(backendMsgId);
              const isNewer =
                Number.isFinite(prevNum) && Number.isFinite(nextNum)
                  ? nextNum > prevNum
                  : backendMsgId > currentTtsMsgId;
              if (!isNewer) {
                return;
              }
              stopTTS();
              wsTtsMsgIdRef.current = backendMsgId;
              wsTtsLocalMsgIdRef.current = activeMsgId;
              wsTtsMsgIdMapRef.current.set(backendMsgId, activeMsgId);
              wsTtsSeenSeqRef.current = new Set();
              wsTtsSeenUrlRef.current = new Set();
            }

            const seq = Number(payload?.play_seq);
            if (Number.isFinite(seq)) {
              if (wsTtsSeenSeqRef.current.has(seq)) return;
              wsTtsSeenSeqRef.current.add(seq);
            }
            if (wsTtsSeenUrlRef.current.has(audioData)) return;
            wsTtsSeenUrlRef.current.add(audioData);

            const fallbackMsgId =
              wsTtsLocalMsgIdRef.current ||
              wsTtsMsgIdMapRef.current.get(backendMsgId) ||
              currentMsgIdRef_ws.current ||
              backendMsgId;
            const targetHistoryItem = chatHistoryRef.current.find(
              (item) =>
                item.msgId === fallbackMsgId || item.messageId === backendMsgId,
            );
            const queueMsgId = targetHistoryItem?.msgId || fallbackMsgId;
            if (targetHistoryItem?.msgId) {
              wsTtsMsgIdMapRef.current.set(
                backendMsgId,
                targetHistoryItem.msgId,
              );
            }
            const audioUrl = getPlayableAudioUrl(audioData);
            const playbackBlocked =
              queueMsgId !== activeMsgId ||
              isTtsPlaybackBlocked([
                backendMsgId,
                fallbackMsgId,
                queueMsgId,
                activeMsgId,
              ]);
            setChatHistory((prev) =>
              prev.map((item) => {
                const isTarget =
                  item.msgId === queueMsgId || item.messageId === backendMsgId;
                if (!isTarget) return item;
                wsTtsMsgIdMapRef.current.set(backendMsgId, item.msgId);
                return {
                  ...item,
                  audioUrl: item.audioUrl || audioUrl,
                  audioUrls: [...(item.audioUrls || []), audioUrl],
                  isPlaying: playbackBlocked ? false : item.isPlaying,
                };
              }),
            );
            if (!playbackBlocked) {
              resumeTTS();
              enqueueAudio(audioUrl, queueMsgId);
            }
            return;
          }

          if (name === "location_saved") {
            if (payload?.ok) {
              console.log("Location saved:", payload.loc);
            } else {
              console.warn("Location save failed:", payload?.error);
            }
            return;
          }

          if (name === "city_hotel_sse") {
            const pType = payload?.type;
            const text = payload?.text || "";
            const msgId = currentMsgIdRef_ws.current;

            console.log("[city_hotel_sse]", pType, text.slice(0, 80));

            if (pType === "start") {
              hotelStreamBufferRef.current = "";
              hotelStreamTextBufferRef.current = "";
              return;
            }

            if (pType === "end") {
              const raw =
                hotelStreamTextBufferRef.current ||
                hotelStreamBufferRef.current;
              hotelStreamBufferRef.current = "";
              hotelStreamTextBufferRef.current = "";
              console.log("[city_hotel_sse] end, buffer length:", raw.length);
              if (!msgId) return;

              const { hotelCards: hotels, content: hotelAnswerText } =
                extractCityHotelSseData(raw);

              console.log("[city_hotel_sse] parsed hotels:", hotels.length);
              if (hotels.length > 0 || hotelAnswerText) {
                setChatHistory((prev) => {
                  const index = prev.findIndex((item) => item.msgId === msgId);
                  if (index === -1) return prev;
                  const newHistory = [...prev];
                  const prevItem = newHistory[index];
                  const existingHotels = prevItem.hotelCards || [];
                  newHistory[index] = {
                    ...prevItem,
                    hotelCards: [...existingHotels, ...hotels],
                    ...(hotelAnswerText ? { content: hotelAnswerText } : {}),
                  };
                  return newHistory;
                });
                let chatDiv = document.querySelector(".ChatDiv");
                if (chatDiv) {
                  setTimeout(() => {
                    chatDiv.scrollTop = chatDiv.scrollHeight;
                  }, 100);
                }
              }
              return;
            }

            if (pType === "thinking") {
              if (!currentMsgIdRef_ws.current) return;
              const t = text.trim();
              if (t) {
                wsHandlersRef.current.setShowThinking(true);
                wsHandlersRef.current.setIsThinking(true);
                wsHandlersRef.current.setThinkingSteps((prev) => {
                  if (prev[prev.length - 1] === t) return prev;
                  return [...prev, t];
                });
              }
              return;
            }

            if (pType !== "answer" && pType !== "raw") return;
            if (!text) {
              if (pType === "raw") {
                hotelStreamTextBufferRef.current += "\n";
                hotelStreamBufferRef.current += "\n";
              }
              return;
            }

            hotelStreamTextBufferRef.current += text;
            hotelStreamBufferRef.current += normalizeItineraryMarkdownChunk(
              hotelStreamBufferRef.current,
              text,
            );
            const normalizedHotelContent = normalizeMarkdownForRender(
              hotelStreamBufferRef.current,
              { source: "city_hotel_sse" },
            );

            if (!msgId) return;
            wsHandlersRef.current.setIsThinking(false);

            let chatDiv = document.querySelector(".ChatDiv");
            if (chatDiv) chatDiv.scrollTop = chatDiv.scrollHeight;

            setChatHistory((prev) => {
              const index = prev.findIndex((item) => item.msgId === msgId);
              if (index === -1) return prev;
              const newHistory = [...prev];
              const prevItem = newHistory[index];
              newHistory[index] = {
                ...prevItem,
                content: normalizedHotelContent || prevItem.content || "",
              };
              return newHistory;
            });
            return;
          }

          if (MARKDOWN_SSE_EVENT_NAMES.has(name)) {
            const pType = payload?.type;
            const text = payload?.text || "";
            if (pType === "start") return;
            if (pType === "end") {
              const msgId = currentMsgIdRef_ws.current;
              if (!msgId) return;
              const prevContent =
                typewriterTargetContentRef.current.get(msgId) ||
                chatHistoryRef.current.find((item) => item.msgId === msgId)
                  ?.content ||
                "";
              if (!prevContent.endsWith("\n\n")) {
                appendTypewriterContent(
                  msgId,
                  prevContent.endsWith("\n") ? "\n" : "\n\n",
                );
              }
              return;
            }
            if (pType !== "raw" && pType !== "answer") return;
            if (!text) return;

            const msgId = currentMsgIdRef_ws.current;
            if (!msgId) return;

            wsHandlersRef.current.setIsThinking(false);
            scrollChatToBottom(0);
            appendMarkdownTypewriterContent(msgId, text);
            return;
          }

          if (name === "maps_route_planning") {
            const pType = payload?.type;
            if (pType === "start" || pType === "end") return;
            if (pType !== "data") return;
            if (!payload?.route) return;

            const msgId = currentMsgIdRef_ws.current;
            if (msgId) {
              pendingRouteCardsRef.current.push(payload);
            }
            return;
          }

          if (name && payload?.pois && payload.pois.length > 0) {
            const msgId = currentMsgIdRef_ws.current;
            if (!msgId) return;

            const mapCardData = {
              tool: payload.tool || name,
              keywords: payload.keywords || "",
              location: payload.location || "",
              radius: payload.radius,
              pois: payload.pois,
              pois_count: payload.pois_count,
            };

            pendingMapCardsRef.current.push(mapCardData);
          }

          if (payload?.type === "thinking") {
            if (!currentMsgIdRef_ws.current) return;
            const t = (payload?.text || "").trim();
            if (t) {
              wsHandlersRef.current.setShowThinking(true);
              wsHandlersRef.current.setIsThinking(true);
              wsHandlersRef.current.setThinkingSteps((prev) => {
                if (prev[prev.length - 1] === t) return prev;
                return [...prev, t];
              });
            }
            return;
          }

          return;
        }
      };

      ws.onerror = (err) => {
        if (wsRef.current === ws) {
          wsConnectingSessionIdRef.current = "";
          wsConnectingLangRef.current = "";
        }
        clearTimeout(connectionTimeout);
        console.error("WebSocket error:", err);
      };

      ws.onclose = (event) => {
        if (wsRef.current === ws) {
          wsConnectingSessionIdRef.current = "";
          wsConnectingLangRef.current = "";
          wsConnectionLangRef.current = "";
        }
        console.log("WebSocket closed:", event.code, event.reason);
        if (wsPingTimerRef.current) {
          clearInterval(wsPingTimerRef.current);
          wsPingTimerRef.current = null;
        }
        if (event.code !== 1000 && wsReconnectAttemptsRef.current < 5) {
          wsReconnectAttemptsRef.current++;
          const delay = Math.min(
            1000 * Math.pow(2, wsReconnectAttemptsRef.current),
            30000,
          );
          console.log(
            `WebSocket reconnecting in ${delay / 1000}s (attempt ${wsReconnectAttemptsRef.current})`,
          );
          wsReconnectTimerRef.current = setTimeout(() => {
            connectWebSocket(wsSessionIdRef.current);
          }, delay);
        }
      };
    },
    [
      cleanupWebSocket,
      fetchPresignedWsUrl,
      getCurrentWsLang,
      getOrCreateBrowserId,
      syncCurrentWsMessageId,
    ],
  );

  const handleToggleDeepThinking = useCallback(() => {
    const next = !deepThinking;
    setDeepThinking(next);
    try {
      localStorage.setItem(DEEP_THINKING_KEY, String(next));
    } catch {
      /* ignore */
    }
  }, [deepThinking]);

  useEffect(() => {
    return () => {
      cleanupWebSocket();
    };
  }, [cleanupWebSocket]);

  useEffect(() => {
    const handleWsLanguageChange = (lng) => {
      const wsLang = getWsLangFromLocale(lng);
      const hasWsToReconnect =
        Boolean(wsRef.current) ||
        Boolean(wsConnectingSessionIdRef.current) ||
        Boolean(wsReconnectTimerRef.current);

      if (!hasWsToReconnect || !wsSessionIdRef.current) return;
      if (
        wsRef.current?.readyState === WebSocket.OPEN &&
        wsConnectionLangRef.current === wsLang
      ) {
        return;
      }

      wsReconnectAttemptsRef.current = 0;
      connectWebSocket(wsSessionIdRef.current, { force: true, lang: wsLang });
    };

    i18n.on("languageChanged", handleWsLanguageChange);
    return () => {
      i18n.off("languageChanged", handleWsLanguageChange);
    };
  }, [connectWebSocket, i18n]);

  useEffect(() => {
    const ensureWsConnected = () => {
      if (!wsSessionIdRef.current) return;
      if (
        wsRef.current?.readyState === WebSocket.OPEN ||
        wsRef.current?.readyState === WebSocket.CONNECTING
      ) {
        return;
      }
      wsReconnectAttemptsRef.current = 0;
      connectWebSocket(wsSessionIdRef.current, { force: true });
    };

    const handleVisibilityChange = () => {
      if (document.visibilityState === "visible") {
        ensureWsConnected();
      }
    };

    window.addEventListener("online", ensureWsConnected);
    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      window.removeEventListener("online", ensureWsConnected);
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, [connectWebSocket]);

  const switchWsSession = useCallback(
    (newSessionId) => {
      if (!newSessionId) return;
      const wsLang = getCurrentWsLang();
      if (
        wsSessionIdRef.current === newSessionId &&
        wsRef.current?.readyState === WebSocket.OPEN &&
        wsConnectionLangRef.current === wsLang
      ) {
        return;
      }
      wsReconnectAttemptsRef.current = 0;
      connectWebSocket(newSessionId);
    },
    [connectWebSocket, getCurrentWsLang],
  );

  const sendWsMessage = useCallback(
    (content) => {
      const ws = wsRef.current;
      if (ws?.readyState === WebSocket.CONNECTING) {
        pendingMessagesRef.current.push(content);
        return true;
      }
      if (!ws || ws.readyState !== WebSocket.OPEN) {
        pendingMessagesRef.current.push(content);
        connectWebSocket(wsSessionIdRef.current);
        return true;
      }
      const msg = {
        type: "text",
        content,
        session_id: wsSessionIdRef.current,
        metadata: { message_id: String(Date.now()) },
      };
      ws.send(JSON.stringify(msg));
      return true;
    },
    [connectWebSocket],
  );

  const detectLanguage = (text) => {
    if (/[\u0600-\u06FF]/.test(text)) {
      return "ar";
    }
    return "unknown";
  };

  const normalizeItineraryMarkdownChunk = (prevContent = "", chunk = "") => {
    if (!chunk) return "";
    let normalized = String(chunk).replace(/\r\n/g, "\n");
    normalized = normalized.replace(/^---+\s*(#{1,6}\s)/, "$1");

    const enforceStrongBoundarySpacing = (text = "") => {
      if (!text.includes("**")) return text;
      const isWordLike = (ch = "") => /[A-Za-z0-9\u4E00-\u9FFF]/.test(ch);

      let output = "";
      let inStrong = false;
      for (let i = 0; i < text.length; i++) {
        if (text[i] === "*" && text[i + 1] === "*") {
          const prevChar = output[output.length - 1] || "";
          const nextChar = text[i + 2] || "";

          // opening ** 前面紧贴中文/字母数字时，补空格
          if (!inStrong && isWordLike(prevChar) && prevChar !== " ") {
            output += " ";
          }

          output += "**";
          inStrong = !inStrong;

          // closing ** 后面紧贴中文/字母数字时，补空格
          if (!inStrong && isWordLike(nextChar) && nextChar !== " ") {
            output += " ";
          }

          i += 1;
          continue;
        }
        output += text[i];
      }
      return output;
    };
    normalized = enforceStrongBoundarySpacing(normalized);

    const hasPrev = prevContent.length > 0;
    const prevEndsWithNewline = /\n\s*$/.test(prevContent);
    const isStandaloneHr = /^\s*(?:---+|\*\*\*+|___+)\s*$/.test(normalized);
    if (isStandaloneHr) {
      // 强制把 --- / *** / ___ 当成分割线块，避免被上一行当作 Setext 标题下划线。
      const prevHasBlankLine = /\n\s*\n\s*$/.test(prevContent);
      const prefix = !hasPrev
        ? ""
        : prevHasBlankLine
          ? ""
          : prevEndsWithNewline
            ? "\n"
            : "\n\n";
      return `${prefix}${normalized.trim()}\n`;
    }

    if (!hasPrev || prevEndsWithNewline) return normalized;

    if (/^\s*(?:#{1,6}\s|```|~~~)/.test(normalized)) {
      return `\n\n${normalized}`;
    }
    if (/^\s*(?:\d+[.)]\s|[-+*]\s|>\s?|\|)/.test(normalized)) {
      return `\n${normalized}`;
    }
    if (/^\s*\[\^[^\]]+\]:/.test(normalized)) {
      return `\n${normalized}`;
    }

    // 流式分片里常出现“独立加粗行/链接行”被直接拼到上一段后面，
    // 会导致 ** 粗体定界跨块，出现加粗前后失效。
    const looksStandaloneStrongLine =
      /^\s*(?:\*\*[^*\n]+(?:\[[^\]]+\]\([^)]+\))?[^*\n]*\*\*|__[^_\n]+__)\s*$/.test(
        normalized,
      );
    const looksStandaloneLinkLine =
      /^\s*(?:\*\*)?\[[^\]]+\]\([^)]+\)(?:\*\*)?\s*$/.test(normalized);
    if (looksStandaloneStrongLine || looksStandaloneLinkLine) {
      return `\n${normalized}`;
    }

    return normalized;
  };

  const extractCityHotelSseData = (buffer = "") => {
    const source = String(buffer || "");
    const hotelCards = [];
    if (!source) {
      return { hotelCards, content: "" };
    }

    let depth = 0;
    let objStart = -1;
    let lastTextStart = 0;
    const textParts = [];

    for (let i = 0; i < source.length; i++) {
      const ch = source[i];
      if (ch === "{") {
        if (depth === 0) objStart = i;
        depth += 1;
      } else if (ch === "}" && depth > 0) {
        depth -= 1;
        if (depth === 0 && objStart >= 0) {
          const segment = source.slice(objStart, i + 1);
          let parsed = null;
          try {
            parsed = JSON.parse(segment);
          } catch (_) {}

          if (parsed?.type === "hotel" && parsed?.hotel_data) {
            hotelCards.push(parsed);
            textParts.push(source.slice(lastTextStart, objStart));
            lastTextStart = i + 1;
          }

          objStart = -1;
        }
      }
    }

    textParts.push(source.slice(lastTextStart));
    const content = normalizeMarkdownForRender(textParts.join(""), {
      source: "city_hotel_sse",
    });

    return { hotelCards, content };
  };

  const formatDocDetails = (docDetails) => {
    if (!Array.isArray(docDetails)) return [];
    return docDetails
      .map((item) => {
        const msg = item?.doc_message || {};
        const link = msg?.url || "";
        const title = msg?.title || "";
        if (!link || !title) return null;
        return {
          link,
          title,
          img: msg?.meta_images || "",
          time: msg?.publish_time || "",
        };
      })
      .filter(Boolean);
  };

  const extractCityHotelToolResultContent = (toolResults) => {
    const answerText = toolResults?.city_hotel?.answer_text || "";
    if (!answerText) return "";
    return normalizeMarkdownForRender(answerText, {
      source: "city_hotel_sse",
    });
  };

  const pickBestCityHotelContent = (candidates = []) => {
    const normalizedCandidates = candidates
      .map((value) => String(value || "").trim())
      .filter(Boolean);
    if (normalizedCandidates.length === 0) return "";
    if (normalizedCandidates.length === 1) return normalizedCandidates[0];
    const maxLength = Math.max(
      ...normalizedCandidates.map((text) => text.length),
    );
    const structuredContent = normalizedCandidates[0];
    const structuredLineCount = structuredContent.split("\n").length;
    const structuredBlockScore =
      (structuredContent.match(/\n#{1,6}\s/g) || []).length +
      (structuredContent.match(/\n[-+*]\s/g) || []).length +
      (structuredContent.match(/\[[^\]]+\]\([^)]+\)/g) || []).length;

    if (
      structuredContent.length >= maxLength * 0.45 &&
      structuredLineCount >= 5 &&
      structuredBlockScore >= 2
    ) {
      return structuredContent;
    }

    const score = (text) => {
      const headingScore = (text.match(/\n#{1,6}\s/g) || []).length * 50;
      const listScore = (text.match(/\n[-+*]\s/g) || []).length * 18;
      const linkScore = (text.match(/\[[^\]]+\]\([^)]+\)/g) || []).length * 8;
      const lineCount = text.split("\n").length;
      const newlineScore = Math.max(0, lineCount - 1) * 5;
      const oddStrongPenalty =
        (text.match(/\*\*/g) || []).length % 2 === 0 ? 0 : 280;
      const longSingleBlockPenalty =
        lineCount <= 3 && text.length > 500 ? 380 : 0;
      return (
        text.length +
        headingScore +
        listScore +
        linkScore +
        newlineScore -
        oddStrongPenalty -
        longSingleBlockPenalty
      );
    };

    return normalizedCandidates.reduce((best, current) =>
      score(current) > score(best) ? current : best,
    );
  };

  const startChat = async (msg = "", type = "new") => {
    if (isLoading || (msg === "" && inputValue === "")) {
      return;
    }
    setPauseChatStatus(false);
    setRenderedMessageCount(CHAT_RENDER_INITIAL_COUNT);
    pendingHistoryPrependRef.current = null;
    // 先停止 useAudioQueue 正在进行的队列播放
    stopTTS();
    blockPriorSystemTts(chatHistoryRef.current);
    cleanupAllTypewriters({ flush: true });
    wsTtsMsgIdRef.current = "";
    wsTtsLocalMsgIdRef.current = "";
    wsTtsMsgIdMapRef.current = new Map();
    wsTtsSeenSeqRef.current = new Set();
    wsTtsSeenUrlRef.current = new Set();
    setChatHistory((prev) =>
      prev.map((msg) => ({
        ...msg,
        isPlaying: false,
      })),
    );
    const localMessageId = new Date().getTime();
    const userMsgId = `${localMessageId}_user`;
    let msgId = `${localMessageId}_ai`;
    const aiMessage = {
      msgId: msgId,
      userMsgId: userMsgId,
      content: "",
      role: "system",
      isEditing: false,
      isPlaying: isMobile ? false : true,
      messageId: "",
      documents: [],
      audioUrl: "",
      audioUrls: [],
      mapCards: [],
      routeCards: [],
      hotelCards: [],
      isFinished: "",
      like: false,
      downVote: false,
      language: "",
    };
    if (type === "refresh") {
      setChatHistory((prev) => {
        const newHistory = [...prev];
        newHistory.pop();
        newHistory.push(aiMessage);

        return newHistory;
      });
    }
    if (type === "new") {
      setChatHistory((prev) => [
        ...prev,
        {
          msgId: userMsgId,
          content: msg || inputValue,
          role: "user",
          isEditing: false,
          messageId: "",
          language: detectLanguage(msg || inputValue)
            ? detectLanguage(msg || inputValue)
            : "",
        },
        aiMessage,
      ]);
    }
    const promptText = msg || inputValue;
    setInputValue("");
    setIsLoading(true);
    currentMsgIdRef_ws.current = msgId;
    setIsThinking(true);
    setShowThinking(true);
    setThinkingSteps([]);
    pendingMapCardsRef.current = [];
    pendingRouteCardsRef.current = [];
    pendingHotelDataRef.current = [];
    hotelStreamBufferRef.current = "";
    hotelStreamTextBufferRef.current = "";

    let chatDiv = document.querySelector(".ChatDiv");
    if (chatDiv !== null) {
      setTimeout(() => {
        chatDiv.scrollTop = chatDiv?.scrollHeight;
      }, 100);
    }

    if (!firstHandled.current && !chatIdSelect) {
      firstHandled.current = true;
      const newWsSessionId = generateWsSessionId();
      wsSessionIdRef.current = newWsSessionId;
      setChatIdSelect(newWsSessionId);
      switchWsSession(newWsSessionId);
      sendWsMessage(promptText);

      // 本地只保留第一条问题作为标题 + sessionId；完整聊天记录由服务端存储
      const historyItem = {
        title: promptText,
        chatId: newWsSessionId,
        wsSessionId: newWsSessionId,
        editorStatus: false,
        timestamp: Date.now(),
      };
      setHistoryList((prev) => {
        const updated = [...prev, historyItem];
        localStorage.setItem("historyListData", JSON.stringify(updated));
        const recentData = filterLast7Days(updated);
        const sortedData = [...recentData].sort(
          (a, b) => b.timestamp - a.timestamp,
        );
        return sortedData;
      });
    } else {
      if (!wsRef.current || wsRef.current.readyState !== WebSocket.OPEN) {
        switchWsSession(wsSessionIdRef.current);
      }
      sendWsMessage(promptText);
    }
  };
  const pauseChat = () => {
    let itemData = chatHistory[chatHistory.length - 1];
    if (itemData?.role === "system") {
      blockPriorSystemTts(
        chatHistoryRef.current.filter((m) => m.msgId === itemData.msgId),
      );
    } else {
      blockTtsPlayback(itemData);
    }
    setPauseChatStatus(true);
    setIsLoading(false);
    if (itemData?.msgId) {
      flushTypewriterQueue(itemData.msgId);
      cleanupTypewriter(itemData.msgId);
    }
    currentMsgIdRef_ws.current = null;
    setIsThinking(false);
    setShowThinking(false);
    setThinkingSteps([]);
    pendingMapCardsRef.current = [];
    pendingRouteCardsRef.current = [];
    pendingHotelDataRef.current = [];
    hotelStreamBufferRef.current = "";
    hotelStreamTextBufferRef.current = "";

    if (itemData && isPlayingMsgId(itemData.msgId)) {
      if (controllerRef.current) {
        controllerRef.current.abort();
        controllerRef.current = null;
      }
      stopTTS();
      setChatHistory((prev) =>
        prev.map((msg) =>
          msg.msgId === itemData.msgId ? { ...msg, isPlaying: false } : msg,
        ),
      );
    }
  };

  useEffect(() => {
    let isMobile = /Android|webOS|iPhone|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent,
    );
    setIsMobile(isMobile);

    // 初始化时从 localStorage 取
    const stored = localStorage.getItem("historyListData");
    if (stored) {
      const recentData = filterLast7Days(JSON.parse(stored));
      const sortedData = [...recentData].sort(
        (a, b) => b.timestamp - a.timestamp,
      );

      setHistoryList(sortedData);
    }
    const current = (
      localStorage.getItem("language") ||
      i18n.resolvedLanguage ||
      i18n.language ||
      "en"
    ).split("-")[0];
    setLangText(languageTextMap[current]);
    if (current === "zh") {
      setDefaultSelectedKeys("1");
    } else if (current === "en") {
      setDefaultSelectedKeys("2");
    } else if (current === "ar") {
      setDefaultSelectedKeys("6");
    } else if (current === "es") {
      setDefaultSelectedKeys("3");
    } else if (current === "fr") {
      setDefaultSelectedKeys("4");
    } else if (current === "ru") {
      setDefaultSelectedKeys("5");
    }
  }, []);

  // 保留7天数据
  const filterLast7Days = (list) => {
    const sevenDaysAgo = Date.now() - 7 * 24 * 60 * 60 * 1000; // 计算7天前的时间戳
    // const sevenDaysAgo = Date.now() -  60 * 60 * 1000; // 计算7天前的时间戳

    const filteredList = list.filter((item) => {
      return item.timestamp > sevenDaysAgo; // 过滤掉早于7天前的数据
    });

    return filteredList;
  };

  const clearSttSilenceTimer = () => {
    if (sttSilenceTimerRef.current) {
      clearTimeout(sttSilenceTimerRef.current);
      sttSilenceTimerRef.current = null;
    }
  };

  const appendSttText = (baseText = "", speechText = "") => {
    const base = String(baseText || "");
    const speech = String(speechText || "");
    if (!base) return speech;
    if (!speech) return base;
    const shouldAddSpace =
      /[A-Za-z0-9]$/.test(base) && /^[A-Za-z0-9]/.test(speech);
    return `${base}${shouldAddSpace ? " " : ""}${speech}`;
  };

  const getSttWsUrl = useCallback(() => {
    const sessionId =
      wsSessionIdRef.current || chatIdSelect || generateWsSessionId();
    if (!wsSessionIdRef.current) {
      wsSessionIdRef.current = sessionId;
    }
    const params = new URLSearchParams({
      session_id: sessionId,
      lang: getCurrentWsLang(),
      sample_rate: String(STT_SAMPLE_RATE),
      encoding: "pcm",
    });
    return `${STT_WS_BASE_URL}/ws/stt?${params.toString()}`;
  }, [chatIdSelect, getCurrentWsLang]);

  const downsampleToPcm16 = (inputData, inputSampleRate) => {
    const sampleRate = inputSampleRate || STT_SAMPLE_RATE;
    const ratio = sampleRate / STT_SAMPLE_RATE;
    const outputLength = Math.max(1, Math.round(inputData.length / ratio));
    const pcm = new Int16Array(outputLength);

    for (let i = 0; i < outputLength; i++) {
      const start = Math.floor(i * ratio);
      const end = Math.min(Math.floor((i + 1) * ratio), inputData.length);
      let sum = 0;
      let count = 0;
      for (let j = start; j < end; j++) {
        sum += inputData[j];
        count += 1;
      }
      const sample = Math.max(-1, Math.min(1, sum / Math.max(1, count)));
      pcm[i] = sample < 0 ? sample * 0x8000 : sample * 0x7fff;
    }

    return pcm.buffer;
  };

  const cleanupSttAudio = useCallback(() => {
    if (sttProcessorRef.current) {
      sttProcessorRef.current.onaudioprocess = null;
      sttProcessorRef.current.disconnect();
      sttProcessorRef.current = null;
    }
    if (sttSourceRef.current) {
      sttSourceRef.current.disconnect();
      sttSourceRef.current = null;
    }
    if (sttMediaStreamRef.current) {
      sttMediaStreamRef.current.getTracks().forEach((track) => track.stop());
      sttMediaStreamRef.current = null;
    }
    if (sttAudioContextRef.current) {
      sttAudioContextRef.current.close?.();
      sttAudioContextRef.current = null;
    }
  }, []);

  const stopRecognition = useCallback(
    (options = {}) => {
      const { resumeAudio = true, notifyBackend = true } = options;
      clearSttSilenceTimer();
      setIsListening(false);
      cleanupSttAudio();

      const ws = sttWsRef.current;
      sttWsRef.current = null;
      if (ws) {
        if (notifyBackend && ws.readyState === WebSocket.OPEN) {
          ws.send(JSON.stringify({ type: "stop" }));
          setTimeout(() => {
            if (
              ws.readyState === WebSocket.OPEN ||
              ws.readyState === WebSocket.CONNECTING
            ) {
              ws.close();
            }
          }, 300);
        } else if (
          ws.readyState === WebSocket.OPEN ||
          ws.readyState === WebSocket.CONNECTING
        ) {
          ws.close();
        }
      }

      voiceText = "";
      if (resumeAudio) {
        resumeTTS();
      }
    },
    [cleanupSttAudio, resumeTTS],
  );

  const scheduleSttSilenceStop = useCallback(() => {
    clearSttSilenceTimer();
    sttSilenceTimerRef.current = setTimeout(() => {
      stopRecognition();
    }, STT_SILENCE_TIMEOUT_MS);
  }, [stopRecognition]);

  const handleSttResult = useCallback(
    (payload) => {
      if (payload?.type === "stt_stopped") {
        stopRecognition({ notifyBackend: false });
        return;
      }
      if (payload?.type !== "stt_result") return;

      const text = payload?.text || "";
      if (text) {
        scheduleSttSilenceStop();
      }
      if (!payload?.is_final || !text) return;

      voiceText += text;
      const nextInputValue = appendSttText(sttInputBaseRef.current, voiceText);
      setInputText(nextInputValue);
      setInputValue(nextInputValue);
    },
    [scheduleSttSilenceStop, stopRecognition],
  );

  const startRecognition = async () => {
    clearSttSilenceTimer();
    voiceText = "";
    sttInputBaseRef.current = inputValue;
    changeVolume();

    try {
      const ws = new WebSocket(getSttWsUrl());
      sttWsRef.current = ws;

      ws.onopen = async () => {
        try {
          const stream = await navigator.mediaDevices.getUserMedia({
            audio: {
              channelCount: 1,
              echoCancellation: true,
              noiseSuppression: true,
              autoGainControl: true,
            },
          });
          const AudioContextClass =
            window.AudioContext || window.webkitAudioContext;
          const audioContext = new AudioContextClass();
          const source = audioContext.createMediaStreamSource(stream);
          const processor = audioContext.createScriptProcessor(4096, 1, 1);

          sttMediaStreamRef.current = stream;
          sttAudioContextRef.current = audioContext;
          sttSourceRef.current = source;
          sttProcessorRef.current = processor;

          processor.onaudioprocess = (event) => {
            if (ws.readyState !== WebSocket.OPEN) return;
            const inputData = event.inputBuffer.getChannelData(0);
            ws.send(downsampleToPcm16(inputData, audioContext.sampleRate));
          };

          source.connect(processor);
          processor.connect(audioContext.destination);
          setIsListening(true);
          scheduleSttSilenceStop();
        } catch (error) {
          console.error("Failed to start STT audio stream:", error);
          message.error("Voice service unavailable, please try again later.");
          stopRecognition();
        }
      };

      ws.onmessage = (event) => {
        try {
          const payload = JSON.parse(event.data);
          handleSttResult(payload);
        } catch (error) {
          console.error("Failed to parse STT message:", error);
        }
      };

      ws.onerror = (error) => {
        console.error("STT websocket error:", error);
        message.error("Voice service unavailable, please try again later.");
        stopRecognition({ notifyBackend: false });
      };

      ws.onclose = () => {
        if (sttWsRef.current === ws) {
          sttWsRef.current = null;
        }
        cleanupSttAudio();
        clearSttSilenceTimer();
        setIsListening(false);
        voiceText = "";
        resumeTTS();
      };
    } catch (error) {
      console.error("Failed to start STT websocket:", error);
      message.error("Voice service unavailable, please try again later.");
      stopRecognition({ notifyBackend: false });
    }
  };

  // 开启语音转文字，答案播放暂停
  const changeVolume = () => {
    blockTtsPlayback();
    stopTTS();
    // 如果有正在播放的，先停掉
    if (audioRef.current) {
      audioRef.current.pause();
      audioRef.current = null;
    }
    setChatHistory((prev) =>
      prev.map((msg) => ({
        ...msg,
        isPlaying: false,
      })),
    );
  };

  // 是否展开侧边栏
  const changeSwitch = () => {
    setOpenSwitch(!openSwitch);
  };
  // 重命名
  const changeEditorStatus = (historyItem) => {
    setNameValue(historyItem.title);
    setHistoryList((prev) =>
      prev.map((item) => ({
        ...item,
        editorStatus: item.chatId === historyItem.chatId, // 只有被点击的为 true，其余为 false
      })),
    );
    // setEditorStatus(true);
  };
  // 移动端重命名
  const changeEditorStatusPhone = (historyItem) => {
    setShowBubblePhone(false);
    setOpenPopoverId(null);
    setIsModalOpen(true);
    setNameValue(historyItem.title);
    setNameValueData(historyItem);
  };
  // 保存重命名
  const handleOk = () => {
    setIsModalOpen(false);
    setHistoryList((prev) => {
      const updated = prev.map((item) =>
        item.chatId === nameValueData.chatId
          ? { ...item, title: nameValue, editorStatus: false }
          : item,
      );

      // ✅ 保存到 localStorage
      localStorage.setItem("historyListData", JSON.stringify(updated));

      return updated;
    });
    setNameValue("");
    setNameValueData(null);
  };
  // 取消重命名
  const handleCancel = () => {
    setIsModalOpen(false);
    setNameValue("");
    setNameValueData(null);
  };
  // 输入框回车
  const onPressEnter = (e, historyItem) => {
    if (e.key === "Enter") {
      const newValue = e.target.value.trim();
      if (!newValue) return;

      setHistoryList((prev) => {
        const updated = prev.map((item) =>
          item.chatId === historyItem.chatId
            ? { ...item, title: newValue, editorStatus: false }
            : item,
        );

        // ✅ 保存到 localStorage
        localStorage.setItem("historyListData", JSON.stringify(updated));

        return updated;
      });
      setNameValue("");
    }
  };
  // pc端输入框的值
  const handleChangeName = (e) => {
    setNameValue(e.target.value);
  };
  const showDrawer = () => {
    setDrawerOpen(true);
  };
  const onClose = () => {
    setDrawerOpen(false);
  };

  // pc端删除会话历史--移动端删除通用
  const handleDeleteChat = (historyItem) => {
    setDeleteModal(true);
    setDeleteData(historyItem);
    setOpenPopoverId(null);
  };
  const handleCloseDelete = () => {
    setDeleteModal(false);
    setDeleteData(null);
  };
  const handleDelete = () => {
    setHistoryList((prev) => {
      const updated = prev.filter((item) => item.chatId !== deleteData.chatId);

      // ✅ 同步存储到 localStorage
      localStorage.setItem("historyListData", JSON.stringify(updated));

      return updated;
    });
    setDeleteModal(false);
    setDeleteData(null);
    if (chatIdSelect === deleteData.chatId) {
      window.location.reload();
    }
  };

  // 从服务器历史记录的 structured_events 解析卡片与思考步骤
  const parseStructuredEvents = (events) => {
    const mapCards = [];
    const routeCards = [];
    const hotelCards = [];
    const thinkingSteps = [];
    let itineraryContent = "";
    let hotelBuffer = "";

    (Array.isArray(events) ? events : []).forEach((e) => {
      const name = e?.name;
      const payload = e?.payload || {};
      const pType = payload.type;
      const esHotelCards = getEsHotelSearchHotels(name, payload);

      if (pType === "thinking") {
        const t = (payload.text || "").trim();
        if (t && thinkingSteps[thinkingSteps.length - 1] !== t) {
          thinkingSteps.push(t);
        }
      }

      if (esHotelCards.length > 0) {
        hotelCards.push(...esHotelCards);
        return;
      }

      if (name === "maps_route_planning") {
        if (pType === "data" && payload.route) {
          routeCards.push(payload);
        }
        return;
      }

      if (MARKDOWN_SSE_EVENT_NAMES.has(name)) {
        if ((pType === "answer" || pType === "raw") && payload.text) {
          itineraryContent += normalizeItineraryMarkdownChunk(
            itineraryContent,
            payload.text,
          );
        }
        return;
      }

      if (name === "city_hotel_sse") {
        if (pType === "answer" || pType === "raw") {
          const text = payload.text || "";
          hotelBuffer += text || (pType === "raw" ? "\n" : "");
        }
        return;
      }

      if (payload?.pois && payload.pois.length > 0) {
        mapCards.push({
          tool: payload.tool || name,
          keywords: payload.keywords || "",
          location: payload.location || "",
          radius: payload.radius,
          pois: payload.pois,
          pois_count: payload.pois_count,
        });
      }
    });

    const { hotelCards: legacyHotelCards, content: cityHotelContent } =
      extractCityHotelSseData(hotelBuffer);
    hotelCards.push(...legacyHotelCards);

    return {
      mapCards,
      routeCards,
      hotelCards,
      thinkingSteps,
      itineraryContent,
      cityHotelContent,
    };
  };

  // 服务器历史数据 -> chatHistory 结构
  const formatServerHistory = (dataArr) => {
    const result = [];
    (Array.isArray(dataArr) ? dataArr : []).forEach((item) => {
      const msgId = item.msg_id;
      const {
        mapCards,
        routeCards,
        hotelCards,
        thinkingSteps,
        itineraryContent,
        cityHotelContent,
      } = parseStructuredEvents(item.structured_events);
      const cityHotelToolResultContent = extractCityHotelToolResultContent(
        item.tool_results,
      );
      const hasCityHotelSignal =
        Boolean(item?.tool_results?.city_hotel) ||
        (Array.isArray(item?.structured_events)
          ? item.structured_events.some(
              (eventItem) => eventItem?.name === "city_hotel_sse",
            )
          : false);
      const normalizedRobotAnswer = hasCityHotelSignal
        ? normalizeMarkdownForRender(item.robot_answer || "", {
            source: "city_hotel_sse",
          })
        : item.robot_answer || "";
      const docDetails = formatDocDetails(item.doc_detail);
      const ragFallbackDocs = (
        Array.isArray(item.rag_documents) ? item.rag_documents : []
      )
        .map((doc) => {
          const meta = doc?.metadata || {};
          const link = meta?.url || "";
          const title = meta?.title || "";
          if (!link || !title) return null;
          return {
            link,
            title,
            img: meta?.meta_images || "",
            time: meta?.publish_time || "",
          };
        })
        .filter(Boolean);
      const historyDocuments =
        docDetails.length > 0 ? docDetails : ragFallbackDocs;
      const aiContent =
        itineraryContent && itineraryContent.trim()
          ? itineraryContent
          : hasCityHotelSignal
            ? pickBestCityHotelContent([
                cityHotelContent,
                cityHotelToolResultContent,
                normalizedRobotAnswer,
              ])
            : normalizedRobotAnswer;
      const historyAudioUrl = item.audio_s3_url || "";
      const playableHistoryAudioUrl = /^https?:\/\//.test(historyAudioUrl)
        ? historyAudioUrl
        : "";
      const supportStatus = Number(item.support_status);

      result.push({
        msgId: `${msgId}_user`,
        content: item.questions || "",
        role: "user",
        isEditing: false,
        isPlaying: false,
        messageId: msgId,
        language: "",
        history: true,
      });

      result.push({
        msgId: `${msgId}_ai`,
        content: aiContent,
        role: "system",
        isEditing: false,
        isPlaying: false,
        messageId: msgId,
        documents: historyDocuments,
        audioUrl: playableHistoryAudioUrl,
        audioS3Url: historyAudioUrl,
        audioUrls: playableHistoryAudioUrl ? [playableHistoryAudioUrl] : [],
        mapCards,
        routeCards,
        hotelCards,
        isFinished: true,
        like: supportStatus === 1,
        downVote: supportStatus === 2,
        language: "",
        thinkingSteps: thinkingSteps.length ? thinkingSteps : undefined,
        history: true,
      });
    });
    return result;
  };

  const stopAudioPlayback = () => {
    blockTtsPlayback();
    if (controllerRef.current) {
      controllerRef.current.abort();
      controllerRef.current = null;
    }
    stopTTS();
    if (audioRef.current) {
      audioRef.current.pause();
      audioRef.current = null;
    }
    setCurrentPlaying(null);
    wsTtsMsgIdRef.current = "";
    wsTtsLocalMsgIdRef.current = "";
    wsTtsMsgIdMapRef.current = new Map();
    wsTtsSeenSeqRef.current = new Set();
    wsTtsSeenUrlRef.current = new Set();
    setChatHistory((prev) =>
      prev.map((msg) => ({
        ...msg,
        isPlaying: false,
      })),
    );
  };

  const handleSelectChat = (historyItem) => {
    onClose();
    stopAudioPlayback();
    setPauseChatStatus(false);
    setShowThinking(false);
    setIsThinking(false);
    setThinkingSteps([]);
    cleanupAllTypewriters();
    currentMsgIdRef_ws.current = null;
    setRenderedMessageCount(CHAT_RENDER_INITIAL_COUNT);
    pendingHistoryPrependRef.current = null;
    setChatIdSelect(historyItem.chatId);
    firstHandled.current = true;
    setIsHistoryLoading(true);
    historyLoadReqIdRef.current += 1;
    const reqId = historyLoadReqIdRef.current;
    if (historyLoadTimerRef.current) {
      clearTimeout(historyLoadTimerRef.current);
    }
    historyLoadTimerRef.current = setTimeout(() => {
      if (historyLoadReqIdRef.current !== reqId) return;
      setIsHistoryLoading(false);
      message.error(t("history.loadFailed"));
    }, 5000);

    const wsId = historyItem.wsSessionId || historyItem.chatId;
    switchWsSession(wsId);

    fetch(`${API_BASE_URL}/history?session_id=${encodeURIComponent(wsId)}`)
      .then((res) => res.json())
      .then((json) => {
        if (historyLoadReqIdRef.current !== reqId) return;
        if (historyLoadTimerRef.current) {
          clearTimeout(historyLoadTimerRef.current);
          historyLoadTimerRef.current = null;
        }
        if (json?.code !== 200 || !Array.isArray(json?.data)) {
          setChatHistory([]);
          setIsHistoryLoading(false);
          message.error(t("history.loadFailed"));
          return;
        }
        shouldSmoothScrollRef.current = true;
        setRenderedMessageCount(CHAT_RENDER_INITIAL_COUNT);
        pendingHistoryPrependRef.current = null;
        setChatHistory(formatServerHistory(json.data));
        setIsHistoryLoading(false);
      })
      .catch((err) => {
        if (historyLoadReqIdRef.current !== reqId) return;
        if (historyLoadTimerRef.current) {
          clearTimeout(historyLoadTimerRef.current);
          historyLoadTimerRef.current = null;
        }
        setIsHistoryLoading(false);
        console.error("请求失败:", err);
        message.error(t("history.loadFailed"));
      });
  };
  // 每次 chatHistory 更新 → 滚动到最底部
  useEffect(() => {
    if (chatDivRef.current) {
      chatDivRef.current.scrollTo({
        top: chatDivRef.current.scrollHeight,
        behavior: shouldSmoothScrollRef.current ? "smooth" : "auto",
      });
      shouldSmoothScrollRef.current = false;
    }
  }, [chatHistory.length]);

  useEffect(() => {
    return () => {
      cleanupAllTypewriters();
      if (historyLoadTimerRef.current) {
        clearTimeout(historyLoadTimerRef.current);
        historyLoadTimerRef.current = null;
      }
    };
  }, []);

  const cancelShow = () => {
    setShowBubblePhone(false);
    setIsLongPress(false);
  };

  // 移动端显示分享弹窗
  const showShareModalPhone = (e, item) => {
    debugger;
    e.stopPropagation();
    const itemMessageId = item.messageId ? String(item.messageId) : "";
    const data = chatHistory.findIndex((msg) => {
      console.log(msg.role, itemMessageId, msg.messageId);
      return (
        msg.role == "system" && itemMessageId && msg.messageId == itemMessageId
      );
    });
    if (data !== -1) {
      let newArray = [];
      newArray.push(chatHistory[data - 1]);
      newArray.push(item);
      setShareAgentData(newArray);
      setShareModalOpenPhone(true);
    }
  };
  const handleCopy = () => {
    debugger;
    const sharedAiMessage =
      shareAgentData.find((item) => item?.role === "system") ||
      shareAgentData[1] ||
      shareAgentData[0];
    const messageId =
      sharedAiMessage?.messageId || shareAgentData[0]?.msgId?.split("_")[0];
    const url = `${window.location.origin}/share?messageId=${messageId}`; // 拼接路由和参数
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard
        .writeText(url)
        .then(() => {
          message.success(t("toast.copied"));
        })
        .catch((err) => {
          console.error("复制失败:", err);
          fallbackCopyText(url);
        });
    } else {
      fallbackCopyText(url);
    }
  };
  const fallbackCopyText = (text) => {
    const textarea = document.createElement("textarea");
    textarea.value = text;
    textarea.style.position = "fixed"; // 避免滚动跳动
    textarea.style.opacity = 0;
    document.body.appendChild(textarea);
    textarea.select();
    try {
      document.execCommand("copy");
      message.success(t("toast.copied"));
    } catch (err) {
      console.error("复制失败:", err);
      message.error("复制失败，请手动复制");
    }
    document.body.removeChild(textarea);
  };

  // 关闭分享弹窗
  const hideShareModalPhone = () => {
    setShareModalOpenPhone(false);
  };

  // pc端点击修改问题
  const handleClickEditor = (itemData) => {
    setEditorValue(itemData.content);
    setChatHistory((prev) => {
      return prev.map((item) => {
        if (item.msgId === itemData.msgId) {
          return {
            ...item,
            isEditing: true,
          };
        }
        return item;
      });
    });
  };
  // 取消修改
  const handleCloseEditor = (itemData) => {
    setEditorValue("");
    setChatHistory((prev) => {
      return prev.map((item) => {
        if (item.msgId === itemData.msgId) {
          return {
            ...item,
            isEditing: false,
          };
        }
        return item;
      });
    });
  };
  // 点击发送修改后的问题
  const handleSendEditorText = (itemData) => {
    setChatHistory((prev) => {
      return prev.map((item) => {
        if (item.msgId === itemData.msgId) {
          return {
            ...item,
            isEditing: false,
          };
        }
        return item;
      });
    });
    startChat(editorValue);
  };
  // 修改问题时输入框的值
  const handleChangeEditor = (e) => {
    setEditorValue(e.target.value);
  };
  // 移动端修改问题
  const handleClickEditorPhone = (itemData) => {
    setInputValue(itemData.content);
    inputRef.current?.focus();
  };

  const submitSupport = async (itemData, supportStatus) => {
    if (!itemData.messageId || itemData.like || itemData.downVote) return;

    const params = {
      msg_id: itemData.messageId,
      support_status: supportStatus,
    };

    try {
      const response = await fetch(`${API_BASE_URL}/feedback/support`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(params),
      });

      if (!response.ok) {
        console.log("请求失败");
      }

      const result = await response.json();
      if (result.success) {
        setChatHistory((prev) => {
          return prev.map((item) => {
            if (item.msgId === itemData.msgId) {
              return {
                ...item,
                like: supportStatus === 1,
                downVote: supportStatus === 2,
              };
            }
            return item;
          });
        });
      }
    } catch (err) {
      console.log(err.message);
    }
  };

  // 点赞
  const handleClickLike = async (itemData) => {
    submitSupport(itemData, 1);
  };

  // 点踩
  const handleClickDownVote = async (itemData) => {
    submitSupport(itemData, 2);
  };

  // 点击播放音频
  const handlePlay = async (itemData) => {
    stopRecognition();
    // 如果正在播放当前条目 → 停止播放
    if (isPlayingMsgId(itemData.msgId)) {
      blockTtsPlayback(itemData);
      if (controllerRef.current) {
        controllerRef.current.abort(); // 停止流式请求
        controllerRef.current = null;
      }
      stopTTS();
      setChatHistory((prev) =>
        prev.map((msg) =>
          msg.msgId === itemData.msgId ? { ...msg, isPlaying: false } : msg,
        ),
      );
      return;
    }

    // 切换播放前先停掉旧的
    blockTtsPlayback();
    if (controllerRef.current) {
      controllerRef.current.abort();
      controllerRef.current = null;
    }
    stopTTS();
    allowTtsPlayback(itemData);
    setChatHistory((prev) =>
      prev.map((msg) =>
        msg.msgId === itemData.msgId
          ? { ...msg, isPlaying: true }
          : { ...msg, isPlaying: false },
      ),
    );

    if (itemData.history && itemData.audioUrls?.length > 0) {
      resumeTTS();
      itemData.audioUrls.forEach((url) => enqueueAudio(url, itemData.msgId));
      return;
    }

    if (itemData.history) {
      const controller = new AbortController();
      controllerRef.current = controller;
      // "https://www.chinapedia.ai/chat/sseStream",
      fetchEventSource(
        // "https://Chinapedia.goclouds.cn/event/2025/Chinapedia-AI/chinapedia/chat/stream",
        `https://chinapedia-test.goclouds.com/chat/stream-audio/${itemData.messageId}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          signal: controller.signal,
          body: JSON.stringify({}),
          cache: "no-store",
          openWhenHidden: true,
          async onopen(event) {
            const playbackBlocked = isTtsPlaybackBlocked([
              itemData.msgId,
              itemData.messageId,
            ]);
            if (!playbackBlocked) {
              resumeTTS();
            }
            setChatHistory((prev) =>
              prev.map((msg) =>
                msg.msgId === itemData.msgId
                  ? { ...msg, isPlaying: !playbackBlocked }
                  : { ...msg, isPlaying: false },
              ),
            );
          },
          async onmessage(event) {
            if (event.data) {
              const audioUrl = base64ToBlobUrl(event.data, "audio/mp3");
              setChatHistory((prev) =>
                prev.map((msg) =>
                  msg.msgId === itemData.msgId
                    ? {
                        ...msg,
                        audioUrls: [...(msg.audioUrls || []), audioUrl],
                        isPlaying: isTtsPlaybackBlocked([
                          itemData.msgId,
                          itemData.messageId,
                        ])
                          ? false
                          : msg.isPlaying,
                      }
                    : msg,
                ),
              );
              if (!isTtsPlaybackBlocked([itemData.msgId, itemData.messageId])) {
                enqueueAudio(audioUrl, itemData.msgId);
              }
            }
          },
          async onerror(event) {
            console.log("onerror", event);
          },
          async onclose(event) {
            controllerRef.current = null;
            if (!isTtsPlaybackBlocked([itemData.msgId, itemData.messageId])) {
              resumeTTS();
            }
          },
        },
      );
    } else {
      const urls =
        itemData.audioUrls && itemData.audioUrls.length > 0
          ? itemData.audioUrls
          : itemData.audioUrl
            ? [itemData.audioUrl]
            : [];

      if (urls.length === 0) return;

      // 检查 useAudioQueue 是否正在播放相同 msgId 的音频
      if (isPlayingMsgId(itemData.msgId)) {
        // 如果正在播放相同 msgId，则暂停队列播放并返回
        blockTtsPlayback(itemData);
        stopTTS();

        // 设置该条目的 isPlaying 为 false
        setChatHistory((prev) =>
          prev.map((msg) =>
            msg.msgId === itemData.msgId ? { ...msg, isPlaying: false } : msg,
          ),
        );
        return;
      }

      // 再次点击同一条目：若正在播放该条目的任一段，则停止并返回
      if (audioRef.current && currentPlaying && urls.includes(currentPlaying)) {
        blockTtsPlayback(itemData);
        stopTTS();
        audioRef.current.pause();
        audioRef.current = null;
        setCurrentPlaying(null);

        // 播放停止 → 该条 isPlaying = false
        setChatHistory((prev) =>
          prev.map((msg) =>
            msg.msgId === itemData.msgId ? { ...msg, isPlaying: false } : msg,
          ),
        );
        return;
      }

      // 切换到新条目播放前，停止其他播放
      stopTTS();
      if (audioRef.current) {
        audioRef.current.pause();
        audioRef.current = null;
      }

      // 点击新条 → 该条 isPlaying = true，其它 isPlaying = false
      setChatHistory((prev) =>
        prev.map((msg) =>
          msg.msgId === itemData.msgId
            ? { ...msg, isPlaying: true }
            : { ...msg, isPlaying: false },
        ),
      );

      let idx = 0;
      const playNext = () => {
        if (idx >= urls.length) {
          setCurrentPlaying(null);
          audioRef.current = null;

          // 队列播放完毕 → 该条 isPlaying = false
          setChatHistory((prev) =>
            prev.map((msg) =>
              msg.msgId === itemData.msgId ? { ...msg, isPlaying: false } : msg,
            ),
          );
          return;
        }
        const url = urls[idx++];
        const audio = new Audio(url);
        audioRef.current = audio;
        setCurrentPlaying(url);
        audio.onended = playNext;
        audio.play().catch((err) => {
          console.error("播放失败:", err);
          playNext(); // 跳过损坏段
        });
      };

      playNext();
    }
  };

  // 切换语言
  const handleMenuClick = (e) => {
    const langConfig = {
      1: {
        langText: "中文",
        locale: "zh-CN",
      },
      2: {
        langText: "English",
        locale: "en-US",
      },
      3: {
        langText: "Español",
        locale: "es-ES",
      },
      4: {
        langText: "Français",
        locale: "fr-FR",
      },
      5: {
        langText: "Русский",
        locale: "ru-RU",
      },
      6: {
        langText: "العربية",
        locale: "ar-SA",
      },
    };
    if (langConfig[e.key]) {
      const { langText, locale } = langConfig[e.key];
      setLangText(langText);
      setDefaultSelectedKeys(e.key);

      localStorage.setItem("language", locale);
      i18n.changeLanguage(locale);
    }
  };

  // 域名截取
  const getDomain = (url) => {
    try {
      const { origin } = new URL(url); // origin 包含协议 + 域名
      return origin; // https://www.gov.cn
    } catch (e) {
      return "";
    }
  };

  return (
    <>
      {isMobile ? (
        <div
          className="noselect page"
          style={{
            backdropFilter: chatHistory.length === 0 ? "none" : "blur(10px)",
          }}
          onClick={cancelShow}
        >
          {openSwitch ? (
            <div className="openLeftDiv">
              <div className="leftHerder">
                <div className="leftHerderTitle">{t("app.title")}</div>
                <img
                  onClick={changeSwitch}
                  className="switchOpenImg"
                  src={SwitchOpenIcon}
                />
              </div>
              <div className="btnContainer">
                <Button type="primary" icon={<CreateNewIcon />}>
                  {t("cta.create")}
                </Button>
              </div>
              <p className="chatHistoryTitle">{t("history.list.title")}</p>
            </div>
          ) : (
            <div className="leftDiv">
              <img
                onClick={changeSwitch}
                className="switchImg"
                src={SwitchCloseIcon}
              />
              <img className="createImg" src={CreateNewChat} />
            </div>
          )}
          <div
            className="rightDiv"
            style={{ width: openSwitch ? "71.17vw" : "95.8vw" }}
          >
            {isHistoryLoading && (
              <div className="historyLoadingOverlay">
                <div className="historyLoadingContent">
                  <div className="historyLoadingSpinner" />
                  <div className="historyLoadingText">
                    {t("history.loading")}
                  </div>
                </div>
              </div>
            )}
            {chatHistory.length === 0 ? (
              <>
                <img
                  className="menuIcon"
                  onClick={showDrawer}
                  src={PhoneMenuIcon}
                />
                <div className="enterDiv">
                  <div>
                    <div className="enterText_title">{t("app.title")}</div>
                    <div className="enterText_tips">{t("app.subtitle")}</div>
                  </div>
                  <div className="enterInputDiv enterInputDiv_multilineRow">
                    <div className="enterInputDiv_inputDiv enterInputDiv_multiline">
                      <TextArea
                        autoSize={{ minRows: 1, maxRows: 4 }}
                        className="enterInputDiv_input enterInputDiv_multilineInput"
                        type="text"
                        placeholder={t("input.placeholder")}
                        value={inputValue}
                        onChange={(e) => setInputValue(e.target.value)}
                        onCompositionStart={() => setIsComposing(true)} // 中文输入开始
                        onCompositionEnd={() => setIsComposing(false)} // 中文输入结束
                        onPressEnter={(e) => {
                          if (
                            e.key === "Enter" &&
                            !e.shiftKey &&
                            !isComposing
                          ) {
                            e.preventDefault(); // 回车发送，Shift+回车换行
                            if (inputValue.trim()) {
                              startChat();
                              // setInputValue("");
                            }
                          }
                        }}
                        style={{
                          textAlign: current === "ar" ? "right" : "left",
                        }}
                      />
                      {isListening ? (
                        <img
                          onClick={stopRecognition}
                          className="recordIcon"
                          src={RecordingIcon}
                        />
                      ) : (
                        <img
                          onClick={startRecognition}
                          className="recordIcon"
                          src={RecordIcon}
                        />
                      )}
                    </div>
                    <div
                      className="enterInputDiv_button"
                      onClick={() => startChat()}
                      style={{ marginLeft: "10px" }}
                    >
                      <SendIcon />
                    </div>
                  </div>
                  <div className="enterInputDiv_tips">
                    {tipList.map((item) => (
                      <div
                        onClick={(e) => {
                          e.stopPropagation();
                          startChat(item.content);
                          // setInputValue("");
                        }}
                        key={item.id}
                      >
                        {item.title}
                      </div>
                    ))}
                  </div>
                </div>
                <div className="page_footer">
                  {t("footer.terms")} <span>{t("footer.terms.label")}</span>{" "}
                  {t("and.text")} <span>{t("footer.privacy.label")}</span>
                </div>
              </>
            ) : (
              <>
                <div className="header">
                  <img
                    className="menuIcon"
                    onClick={showDrawer}
                    src={PhoneMenuIcon}
                  />
                  <div className="enterText_title1">{t("app.title")}</div>
                  <div
                    className="mobile_addIcon"
                    onClick={(e) => {
                      e.stopPropagation();
                      window.location.reload();
                    }}
                  >
                    <AddIconMobile />
                  </div>
                </div>
                <div
                  className="ChatDiv"
                  ref={chatDivRef}
                  onScroll={handleChatScroll}
                >
                  {/* 模拟地图卡片 - 测试用
                  <div className="agentMessage">
                    <div className="agentBg">Pedia</div>
                    <div className="agentMessage_content">
                      <p>以下是您附近的景点信息：</p>
                      <AmapCard
                        pois={mockMapData.pois}
                        location={mockMapData.location}
                        keywords={mockMapData.keywords}
                      />
                    </div>
                  </div> */}

                  {visibleChatHistory.map(({ item, index }) => {
                    const isLastSystem =
                      index === chatHistory.length - 1 &&
                      item.role === "system";
                    const useLiveThinking =
                      isLastSystem && showThinking && !item.history;
                    const displayThinkingSteps = pauseChatStatus
                      ? []
                      : useLiveThinking
                        ? thinkingSteps
                        : item.thinkingSteps || [];
                    const thinkingActive =
                      !pauseChatStatus && useLiveThinking && isThinking;
                    const showThinkingBlock =
                      !pauseChatStatus &&
                      (displayThinkingSteps.length > 0 || thinkingActive);
                    const showAgentHeader =
                      item.content !== "" || showThinkingBlock;

                    return item.role === "system" ? (
                      <div
                        key={item.msgId || `system-${index}`}
                        className="agentMessage message-animate message-animate-left"
                      >
                        {showAgentHeader ? (
                          <div className="agentBg">Pedia</div>
                        ) : null}
                        {showThinkingBlock ? (
                          <ThinkingProcess
                            steps={displayThinkingSteps}
                            isThinking={thinkingActive}
                          />
                        ) : null}
                        {showThinkingBlock ? (
                          <div className="flex-break" />
                        ) : null}
                        {item.content !== "" ? (
                          <MarkdownContent
                            content={item.content}
                            className={`agentMessage_content${showThinkingBlock ? " has-thinking" : ""}`}
                            dir={item.language === "ar" ? "rtl" : "ltr"}
                          />
                        ) : null}
                        {item.mapCards &&
                          item.mapCards.length > 0 &&
                          item.mapCards.map((card, cardIdx) => (
                            <AmapCard
                              key={`map-${item.msgId}-${cardIdx}`}
                              pois={card.pois}
                              location={card.location}
                              keywords={card.keywords}
                              userLocation={userLocation}
                            />
                          ))}
                        {item.routeCards &&
                          item.routeCards.length > 0 &&
                          item.routeCards.map((route, idx) => (
                            <RouteCard
                              key={`route-${item.msgId}-${idx}`}
                              routeData={route}
                            />
                          ))}
                        {item.hotelCards && item.hotelCards.length > 0 && (
                          <HotelCardList
                            key={`hotels-${item.msgId}`}
                            hotels={item.hotelCards}
                          />
                        )}
                        {item?.isFinished && item.documents.length > 0 && (
                          <div className="sourceArticleContainer">
                            <p className="articleTitle">
                              {t("articles.source")}
                            </p>
                            <div className="articleBody">
                              <div className="referencesItemContainer">
                                {item.documents.length > 0 &&
                                  item.documents?.map((documentItem) => {
                                    const hasDocumentImage = Boolean(
                                      documentItem.img,
                                    );
                                    const referencesItemTopClassName =
                                      hasDocumentImage
                                        ? "referencesItemTop"
                                        : "referencesItemTop noImage";
                                    return (
                                      <a
                                        href={documentItem.link}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                      >
                                        <div className="referencesItem">
                                          {documentItem.img && (
                                            <img src={documentItem.img} />
                                          )}
                                          <p>{documentItem.title}</p>
                                        </div>
                                      </a>
                                    );
                                  })}
                              </div>
                            </div>
                          </div>
                        )}
                        {item.content && (
                          <div className="agentMessage_Tool">
                            {(item?.audioUrl ||
                              item?.audioUrls?.length > 0) && (
                              <div onClick={() => handlePlay(item)}>
                                <img
                                  src={
                                    item?.isPlaying ? RecordingIcon : PlayIcon
                                  }
                                />
                              </div>
                            )}
                            <div
                              className="copyAction"
                              onClick={(e) => {
                                e.stopPropagation();

                                if (
                                  navigator.clipboard &&
                                  navigator.clipboard.writeText
                                ) {
                                  // 现代浏览器 & https/localhost 环境
                                  navigator.clipboard
                                    .writeText(item.content)
                                    .then(() => {
                                      message.success({
                                        content: t("toast.copied"),
                                      });
                                    })
                                    .catch((err) => {
                                      console.error("复制失败:", err);
                                      fallbackCopyText(item.content);
                                    });
                                } else {
                                  // 旧环境 / http 下 fallback
                                  fallbackCopyText(item.content);
                                }
                              }}
                            >
                              <CopyIcon />
                            </div>
                            {index === chatHistory.length - 1 && !isLoading && (
                              <div
                                className="refreshAction"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setIsLoading(true);
                                  startChat(
                                    chatHistory[index - 1].content,
                                    "refresh",
                                  );
                                }}
                              >
                                <FreshIcon />
                              </div>
                            )}
                            <div
                              className="shareAction"
                              onClick={(e) => showShareModalPhone(e, item)}
                            >
                              <img src={ShareIcon} />
                            </div>
                            <div
                              className={`feedbackAction ${
                                item?.like ? "feedbackActionActive" : ""
                              } ${
                                item?.like || item?.downVote
                                  ? "feedbackActionLocked"
                                  : ""
                              }`}
                              onClick={() => handleClickLike(item)}
                            >
                              <img
                                src={item?.like ? LikeActiveIcon : LikeIcon}
                              />
                            </div>
                            <div
                              className={`feedbackAction ${
                                item?.downVote ? "feedbackActionActive" : ""
                              } ${
                                item?.like || item?.downVote
                                  ? "feedbackActionLocked"
                                  : ""
                              }`}
                              onClick={() => handleClickDownVote(item)}
                            >
                              <img
                                src={
                                  item?.downVote
                                    ? DownVoteActiveIcon
                                    : UnLikeIcon
                                }
                              />
                            </div>
                          </div>
                        )}
                      </div>
                    ) : (
                      <div
                        key={item.msgId || `user-${index}`}
                        className="customerContainer message-animate message-animate-right"
                      >
                        <div className="customerMessage">
                          <div dir={item.language === "ar" ? "rtl" : "ltr"}>
                            {item.content}
                          </div>
                          <CustomerIcon />
                        </div>
                        <div className="customerMessage_Tool">
                          <div>
                            <img
                              onClick={() => handleClickEditorPhone(item)}
                              src={EditorIcon}
                            />
                          </div>
                          <div
                            onClick={(e) => {
                              e.stopPropagation();

                              if (
                                navigator.clipboard &&
                                navigator.clipboard.writeText
                              ) {
                                // 现代浏览器 & https/localhost 环境
                                navigator.clipboard
                                  .writeText(item.content)
                                  .then(() => {
                                    message.success({
                                      content: t("toast.copied"),
                                    });
                                  })
                                  .catch((err) => {
                                    console.error("复制失败:", err);
                                    fallbackCopyText(item.content);
                                  });
                              } else {
                                // 旧环境 / http 下 fallback
                                fallbackCopyText(item.content);
                              }
                            }}
                          >
                            <CopyIcon />
                          </div>
                        </div>
                      </div>
                    );
                  })}
                  {isLoading &&
                    (() => {
                      const last = chatHistory[chatHistory.length - 1];
                      return (
                        (last?.role === "system" && !last?.content) ||
                        last?.role !== "system"
                      );
                    })() && <div className="loader"></div>}
                </div>
                <div className="ChatDiv_Input">
                  <div className="ChatDiv_Input_mobile">
                    {tipList.map((item) => (
                      <div
                        className="chatInput_button_item"
                        onClick={(e) => {
                          e.stopPropagation();
                          startChat(item.content);
                          // setInputValue("");
                        }}
                        key={item.id}
                      >
                        {item.title}
                      </div>
                    ))}
                  </div>
                  <div
                    className="ChatDiv_newChat"
                    onClick={(e) => {
                      e.stopPropagation();
                      // 刷新页面
                      window.location.reload();
                    }}
                  >
                    <AddIcon />
                    <span>{t("cta.create")}</span>
                  </div>
                  <div className="enterInputDiv chatInputDiv">
                    <div
                      className="enterInputDiv_inputDiv"
                      style={{
                        width: "100%",
                        height: "85%",
                        borderRadius: "8px",
                      }}
                    >
                      <div className="chatInput">
                        <TextArea
                          ref={inputRef}
                          autoSize={{ minRows: 4, maxRows: 4 }}
                          className="chatInput_input"
                          type="text"
                          placeholder={t("input.placeholder")}
                          value={inputValue}
                          onChange={(e) => setInputValue(e.target.value)}
                          onCompositionStart={() => setIsComposing(true)} // 中文输入开始
                          onCompositionEnd={() => setIsComposing(false)} // 中文输入结束
                          onPressEnter={(e) => {
                            if (e.key === "Enter" && !isComposing) {
                              e.preventDefault(); // 阻止默认换行
                              if (inputValue.trim()) {
                                startChat();
                                // setInputValue("");
                              }
                            }
                          }}
                          style={{
                            textAlign: current === "ar" ? "right" : "left",
                          }}
                        />
                        <div className="chatInput_button">
                          <div
                            className="enterInputDiv_tips"
                            style={{
                              marginTop: 0,
                              maxWidth: "70%",
                              minWidth: "70%",
                              overflowY: "auto",
                              justifyContent: "flex-start",
                              marginLeft: "11px",
                            }}
                          >
                            {tipList.map((item) => (
                              <div
                                className="chatInput_button_item"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  startChat(item.content);
                                  // setInputValue("");
                                }}
                                key={item.id}
                              >
                                {item.title}
                              </div>
                            ))}
                          </div>
                          {isListening ? (
                            <img
                              onClick={stopRecognition}
                              className="recordIcon_button"
                              src={RecordingIcon}
                            />
                          ) : (
                            <img
                              onClick={startRecognition}
                              className="recordIcon_button"
                              src={RecordIcon}
                            />
                          )}
                          <div className="line"></div>
                          {isLoading ? (
                            <div
                              className="enterInputDiv_button"
                              onClick={pauseChat}
                              style={{
                                width: "32px",
                                height: "32px",
                              }}
                            >
                              <img
                                style={{ width: "32px", height: "32px" }}
                                src={PauseIcon}
                              />
                            </div>
                          ) : (
                            <div
                              className="enterInputDiv_button"
                              onClick={() => startChat()}
                              style={{
                                width: "32px",
                                height: "32px",
                                // marginRight: "5px",
                              }}
                            >
                              <SendIconSmall />
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
          <Modal
            wrapClassName="shareModalPhone"
            open={shareModalOpenPhone}
            onCancel={hideShareModalPhone}
          >
            <div className="shareTitle">
              <i></i>
              {t("cta.share")}
            </div>
            <div className="shareContainer">
              {shareAgentData?.map((itemData) => {
                if (itemData.role === "user") {
                  return (
                    <div
                      className="customerMessage"
                      style={{ marginBottom: "20px" }}
                    >
                      <div className="customerText">{itemData?.content}</div>
                      <CustomerIcon />
                    </div>
                  );
                } else {
                  return (
                    <div className="agentMessage">
                      <div class="agentBg">Pedia</div>
                      <MarkdownContent
                        content={itemData?.content}
                        dir={itemData.language === "ar" ? "rtl" : "ltr"}
                      />
                    </div>
                  );
                }
              })}
            </div>
            <div className="btnDiv">
              <Button
                onClick={handleCopy}
                className="copyBtn"
                icon={<LinkIcon />}
                type="primary"
              >
                {t("cta.copy")}
              </Button>
            </div>
          </Modal>

          <Drawer
            title={null}
            placement="left"
            open={drawerOpen}
            onClose={onClose}
          >
            <div className="leftHerder">
              <div className="leftHerderTitle">{t("app.title")}</div>
              <img
                onClick={onClose}
                className="closeReturnIcon"
                src={PhoneReturnIcon}
              />
            </div>
            <div className="phoneListContainer">
              <div className="chatHistoryListContainer">
                {historyList?.map((historyItem) => {
                  const isOpen = openPopoverId === historyItem.chatId;
                  return (
                    <div
                      className={
                        historyItem.chatId === chatIdSelect
                          ? "listItemSelected"
                          : "listItem"
                      }
                    >
                      <p
                        title={historyItem.title}
                        style={{
                          textAlign: current === "ar" ? "right" : "left",
                        }}
                        onClick={() => handleSelectChat(historyItem)}
                      >
                        {historyItem.title}
                      </p>
                      <Popover
                        placement="bottomLeft"
                        content={
                          <div className="operationContainer">
                            <p
                              onClick={() =>
                                changeEditorStatusPhone(historyItem)
                              }
                              className="operationItem"
                            >
                              <img src={EditorIcon} />
                              <span>{t("ui.rename")}</span>
                            </p>
                            <p
                              onClick={() => handleDeleteChat(historyItem)}
                              className="deleteItem"
                            >
                              <img src={DeleteIcon} />
                              <span>{t("ui.delete")}</span>
                            </p>
                          </div>
                        }
                        open={isOpen}
                        onOpenChange={(open) => {
                          setOpenPopoverId(open ? historyItem.chatId : null);
                        }}
                        trigger="click"
                      >
                        <img
                          style={{
                            marginLeft: current === "ar" ? "5px" : "0px",
                          }}
                          src={MoreIcon}
                        />
                      </Popover>
                    </div>
                  );
                })}
              </div>
            </div>
            {/* <div style={{ padding: "8px 16px 0" }}>
              <button
                type="button"
                className={`deep-thinking-toggle ${deepThinking ? "active" : ""}`}
                onClick={handleToggleDeepThinking}
                title={deepThinking ? "关闭深度思考" : "开启深度思考"}
              >
                {deepThinking ? "Thinking" : "Normal"}
              </button>
            </div> */}
            <LanguageSwitcher />

            <Modal
              wrapClassName="editorModalPhone"
              open={isModalOpen}
              closable={false}
            >
              <p
                style={{ textAlign: current === "ar" ? "right" : "left" }}
                className="modalTitle"
              >
                <i
                  style={{
                    float: current === "ar" ? "right" : "left",
                    marginLeft: current === "ar" ? "15px" : "0px",
                  }}
                ></i>
                {t("editor.name.phone")}
              </p>
              <Input
                value={nameValue}
                className="phoneInput"
                onChange={handleChangeName}
                style={{ textAlign: current === "ar" ? "right" : "left" }}
              />
              <div className="modalFooter">
                <div onClick={handleCancel} className="leftFooter">
                  {t("btn.cancel")}
                </div>
                <div onClick={handleOk} className="rightFooter">
                  {t("btn.ok")}
                </div>
              </div>
            </Modal>
          </Drawer>

          {/*删除对话提示弹窗*/}
          <Modal
            style={{ textAlign: current === "ar" ? "right" : "left" }}
            wrapClassName="deleteModalPc"
            footer={null}
            title={t("delete.chat.title")}
            open={deleteModal}
            onCancel={handleCloseDelete}
          >
            <p style={{ textAlign: current === "ar" ? "right" : "left" }}>
              {t("delete.chat.tips.text")}
            </p>
            <div className="btn">
              <Button onClick={handleCloseDelete}>{t("btn.cancel")}</Button>
              <Button onClick={handleDelete} danger>
                {t("ui.delete")}
              </Button>
            </div>
          </Modal>
        </div>
      ) : (
        <div
          className="page"
          style={{
            backdropFilter: chatHistory.length === 0 ? "none" : "blur(10px)",
          }}
          onClick={cancelShow}
        >
          {openSwitch ? (
            <div className="openLeftDiv">
              <div className="leftHerder">
                <div className="leftHerderTitle">{t("app.title")}</div>
                <img
                  onClick={changeSwitch}
                  className="switchOpenImg"
                  src={SwitchOpenIcon}
                />
              </div>
              <div className="btnContainer">
                <Button
                  onClick={(e) => {
                    e.stopPropagation();
                    // 刷新页面
                    window.location.reload();
                  }}
                  type="primary"
                  icon={<CreateNewIcon />}
                >
                  {t("cta.create")}
                </Button>
              </div>
              <p
                className="chatHistoryTitle"
                style={{ textAlign: langText === "العربية" ? "right" : "left" }}
              >
                {t("history.list.title")}
              </p>
              <div className="chatHistoryListContainer">
                {historyList?.map((historyItem) => {
                  return (
                    <>
                      {historyItem.editorStatus ? (
                        <div className="listItemInput">
                          <Input
                            value={nameValue}
                            onChange={handleChangeName}
                            onPressEnter={(e) => onPressEnter(e, historyItem)}
                            style={{
                              textAlign:
                                langText === "العربية" ? "right" : "left",
                            }}
                          />
                        </div>
                      ) : (
                        <div
                          className={
                            historyItem.chatId === chatIdSelect
                              ? "listItemSelected"
                              : "listItem"
                          }
                        >
                          <p
                            title={historyItem.title}
                            style={{
                              textAlign:
                                langText === "العربية" ? "right" : "left",
                            }}
                            onClick={() => handleSelectChat(historyItem)}
                          >
                            {historyItem.title}
                          </p>
                          <Popover
                            placement="bottomLeft"
                            content={
                              <div className="operationContainer">
                                <p
                                  onClick={() =>
                                    changeEditorStatus(historyItem)
                                  }
                                  className="operationItem"
                                >
                                  <img src={EditorIcon} />
                                  <span>{t("ui.rename")}</span>
                                </p>
                                <p
                                  onClick={() => handleDeleteChat(historyItem)}
                                  className="deleteItem"
                                >
                                  <img src={DeleteIcon} />
                                  <span>{t("ui.delete")}</span>
                                </p>
                              </div>
                            }
                            trigger="click"
                          >
                            <img src={MoreIcon} />
                          </Popover>
                        </div>
                      )}
                    </>
                  );
                })}
              </div>
            </div>
          ) : (
            <div className="leftDiv">
              <img
                onClick={changeSwitch}
                className="switchImg"
                src={SwitchCloseIcon}
              />
              <img
                className="createImg"
                src={CreateNewChat}
                onClick={(e) => {
                  e.stopPropagation();
                  // 刷新页面
                  window.location.reload();
                }}
              />
            </div>
          )}
          <div
            className="rightDiv"
            style={{ width: openSwitch ? "83.12vw" : "95.8vw" }}
          >
            {isHistoryLoading && (
              <div className="historyLoadingOverlay">
                <div className="historyLoadingContent">
                  <div className="historyLoadingSpinner" />
                  <div className="historyLoadingText">
                    {t("history.loading")}
                  </div>
                </div>
              </div>
            )}
            <div className="languageContainer">
              {/* <button
                type="button"
                className={`deep-thinking-toggle ${deepThinking ? "active" : ""}`}
                onClick={handleToggleDeepThinking}
                title={deepThinking ? "关闭深度思考" : "开启深度思考"}
              >
                {deepThinking ? "Thinking" : "Normal"}
              </button> */}
              <Dropdown
                menu={{
                  items,
                  selectable: true,
                  defaultSelectedKeys: [defaultSelectedKeys],
                  onClick: handleMenuClick,
                }}
                overlayClassName="langDownPersonal"
              >
                <div>
                  <img src={LanguageIcon} />
                  <span>{langText}</span>
                </div>
              </Dropdown>
            </div>
            {chatHistory.length === 0 ? (
              <>
                <img
                  className="menuIcon"
                  onClick={showDrawer}
                  src={PhoneMenuIcon}
                />
                <div className="enterDiv">
                  <div>
                    <div className="enterText_title">{t("app.title")}</div>
                    <div className="enterText_tips">{t("app.subtitle")}</div>
                  </div>
                  <div className="enterInputDiv enterInputDiv_multilineRow">
                    <div className="enterInputDiv_inputDiv enterInputDiv_multiline">
                      <TextArea
                        autoSize={{ minRows: 1, maxRows: 4 }}
                        className="enterInputDiv_input enterInputDiv_multilineInput"
                        type="text"
                        placeholder={t("input.placeholder")}
                        value={inputValue}
                        onChange={(e) => setInputValue(e.target.value)}
                        onCompositionStart={() => setIsComposing(true)} // 中文输入开始
                        onCompositionEnd={() => setIsComposing(false)} // 中文输入结束
                        onPressEnter={(e) => {
                          if (
                            e.key === "Enter" &&
                            !e.shiftKey &&
                            !isComposing
                          ) {
                            e.preventDefault(); // 回车发送，Shift+回车换行
                            if (inputValue.trim()) {
                              startChat();
                              // setInputValue("");
                            }
                          }
                        }}
                        style={{
                          textAlign: langText === "العربية" ? "right" : "left",
                        }}
                      />
                      {isListening ? (
                        <img
                          onClick={stopRecognition}
                          className="recordIcon"
                          src={RecordingIcon}
                        />
                      ) : (
                        <img
                          onClick={startRecognition}
                          className="recordIcon"
                          src={RecordIcon}
                        />
                      )}
                    </div>
                    <div
                      className="enterInputDiv_button"
                      onClick={() => startChat()}
                      style={{ marginLeft: "10px" }}
                    >
                      <SendIcon />
                    </div>
                  </div>
                  <div className="enterInputDiv_tips">
                    {tipList.map((item) => (
                      <div
                        onClick={(e) => {
                          e.stopPropagation();
                          startChat(item.content);
                          // setInputValue("");
                        }}
                        key={item.id}
                      >
                        {item.title}
                      </div>
                    ))}
                  </div>
                </div>
                <div className="page_footer">
                  {t("footer.terms")} <span>{t("footer.terms.label")}</span>{" "}
                  {t("and.text")} <span>{t("footer.privacy.label")}</span>
                </div>
              </>
            ) : (
              <>
                <div className="header">
                  <img
                    className="menuIcon"
                    onClick={showDrawer}
                    src={PhoneMenuIcon}
                  />
                  <div className="enterText_title1">{t("app.title")}</div>
                  <div
                    className="mobile_addIcon"
                    onClick={(e) => {
                      e.stopPropagation();
                      window.location.reload();
                    }}
                  >
                    <AddIconMobile />
                  </div>
                </div>
                <div
                  className="ChatDiv"
                  ref={chatDivRef}
                  onScroll={handleChatScroll}
                >
                  {/* 模拟地图卡片 - 测试用 */}
                  {/* <div className="agentMessage">
                    <div className="agentBg">Pedia</div>
                    <div className="agentMessage_content">
                      <p>以下是您附近的景点信息：</p>
                      <AmapCard
                        pois={mockMapData.pois}
                        location={mockMapData.location}
                        keywords={mockMapData.keywords}
                      />
                    </div>
                  </div> */}

                  {visibleChatHistory.map(({ item, index }) => {
                    const isLastSystem =
                      index === chatHistory.length - 1 &&
                      item.role === "system";
                    const useLiveThinking =
                      isLastSystem && showThinking && !item.history;
                    const displayThinkingSteps = pauseChatStatus
                      ? []
                      : useLiveThinking
                        ? thinkingSteps
                        : item.thinkingSteps || [];
                    const thinkingActive =
                      !pauseChatStatus && useLiveThinking && isThinking;
                    const showThinkingBlock =
                      !pauseChatStatus &&
                      (displayThinkingSteps.length > 0 || thinkingActive);
                    const showAgentHeader =
                      item.content !== "" || showThinkingBlock;

                    return item.role === "system" ? (
                      <div
                        key={item.msgId || `system-${index}`}
                        className="agentMessage message-animate message-animate-left"
                      >
                        {showAgentHeader ? (
                          <div className="agentBg">Pedia</div>
                        ) : null}
                        {showThinkingBlock ? (
                          <ThinkingProcess
                            steps={displayThinkingSteps}
                            isThinking={thinkingActive}
                          />
                        ) : null}
                        {showThinkingBlock ? (
                          <div className="flex-break" />
                        ) : null}
                        {item.content !== "" ? (
                          <MarkdownContent
                            content={item.content}
                            className={`agentMessage_content${showThinkingBlock ? " has-thinking" : ""}`}
                            dir={item.language === "ar" ? "rtl" : "ltr"}
                          />
                        ) : null}
                        {item.mapCards &&
                          item.mapCards.length > 0 &&
                          item.mapCards.map((card, cardIdx) => (
                            <AmapCard
                              key={`map-${item.msgId}-${cardIdx}`}
                              pois={card.pois}
                              location={card.location}
                              keywords={card.keywords}
                              userLocation={userLocation}
                            />
                          ))}
                        {item.routeCards &&
                          item.routeCards.length > 0 &&
                          item.routeCards.map((route, idx) => (
                            <RouteCard
                              key={`route-${item.msgId}-${idx}`}
                              routeData={route}
                            />
                          ))}
                        {item.hotelCards && item.hotelCards.length > 0 && (
                          <HotelCardList
                            key={`hotels-${item.msgId}`}
                            hotels={item.hotelCards}
                          />
                        )}
                        {item.documents.length > 0 && item.content && (
                          <div className="referencesContainer">
                            <p className="referencesTitle">
                              <img src={ReferencesIcon} />
                              {t("articles.source")}
                            </p>
                            <div className="referencesItemBody">
                              <div className="referencesItemContainer">
                                {item.documents.length > 0 &&
                                  item.documents?.map((documentItem) => {
                                    const hasDocumentImage = Boolean(
                                      documentItem.img,
                                    );
                                    const referencesItemTopClassName =
                                      hasDocumentImage
                                        ? "referencesItemTop"
                                        : "referencesItemTop noImage";
                                    return (
                                      <a
                                        href={documentItem.link}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                      >
                                        <div className="referencesItem">
                                          <div
                                            className={
                                              referencesItemTopClassName
                                            }
                                          >
                                            {hasDocumentImage && (
                                              <img
                                                src={documentItem.img}
                                                onError={(e) => {
                                                  e.currentTarget.style.display =
                                                    "none";
                                                  e.currentTarget.parentElement?.classList.add(
                                                    "noImage",
                                                  );
                                                }}
                                              />
                                            )}
                                            <p>{documentItem.title}</p>
                                          </div>
                                          <div className="referencesItemBottom">
                                            {documentItem.time}
                                            {/* <p
                                                  title={getDomain(
                                                    documentItem.link,
                                                  )}
                                                  class="textHttps"
                                                >
                                                  {getDomain(documentItem.link)}
                                                </p> */}
                                          </div>
                                        </div>
                                      </a>
                                    );
                                  })}
                              </div>
                            </div>
                          </div>
                        )}
                        {item.content && (
                          <div className="agentMessage_Tool">
                            {(item?.audioUrl ||
                              item?.audioUrls?.length > 0) && (
                              <div onClick={() => handlePlay(item)}>
                                <img
                                  src={
                                    item?.isPlaying ? RecordingIcon : PlayIcon
                                  }
                                />
                              </div>
                            )}
                            <div
                              className="copyAction"
                              onClick={(e) => {
                                e.stopPropagation();

                                if (
                                  navigator.clipboard &&
                                  navigator.clipboard.writeText
                                ) {
                                  // 现代浏览器 & https/localhost 环境
                                  navigator.clipboard
                                    .writeText(item.content)
                                    .then(() => {
                                      message.success({
                                        content: t("toast.copied"),
                                      });
                                    })
                                    .catch((err) => {
                                      console.error("复制失败:", err);
                                      fallbackCopyText(item.content);
                                    });
                                } else {
                                  // 旧环境 / http 下 fallback
                                  fallbackCopyText(item.content);
                                }
                              }}
                            >
                              <CopyIcon />
                            </div>
                            {index === chatHistory.length - 1 && !isLoading && (
                              <div
                                className="refreshAction"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setIsLoading(true);
                                  startChat(
                                    chatHistory[index - 1].content,
                                    "refresh",
                                  );
                                }}
                              >
                                <FreshIcon />
                              </div>
                            )}
                            <div className="shareAction">
                              <img
                                onClick={(e) => showShareModalPhone(e, item)}
                                src={ShareIcon}
                              />
                            </div>
                            <div
                              className={`feedbackAction ${
                                item?.like ? "feedbackActionActive" : ""
                              } ${
                                item?.like || item?.downVote
                                  ? "feedbackActionLocked"
                                  : ""
                              }`}
                              onClick={() => handleClickLike(item)}
                            >
                              <img
                                src={item?.like ? LikeActiveIcon : LikeIcon}
                              />
                            </div>
                            <div
                              className={`feedbackAction ${
                                item?.downVote ? "feedbackActionActive" : ""
                              } ${
                                item?.like || item?.downVote
                                  ? "feedbackActionLocked"
                                  : ""
                              }`}
                              onClick={() => handleClickDownVote(item)}
                            >
                              <img
                                src={
                                  item?.downVote
                                    ? DownVoteActiveIcon
                                    : UnLikeIcon
                                }
                              />
                            </div>
                          </div>
                        )}
                      </div>
                    ) : (
                      <div
                        key={item.msgId || `user-${index}`}
                        className="customerContainer message-animate message-animate-right"
                      >
                        <div className="customerMessage">
                          {item?.isEditing ? (
                            <div className="editorContainer">
                              <img
                                onClick={() => handleCloseEditor(item)}
                                src={CloseIcon}
                              />
                              <TextArea
                                autoSize={{ minRows: 2, maxRows: 2 }}
                                type="text"
                                value={editorValue}
                                onChange={handleChangeEditor}
                                dir={item.language === "ar" ? "rtl" : "ltr"}
                              />
                              <div
                                className="enterInputDiv_button"
                                onClick={() => handleSendEditorText(item)}
                              >
                                <SendIconSmall />
                              </div>
                            </div>
                          ) : (
                            <div
                              className="customerText"
                              dir={item.language === "ar" ? "rtl" : "ltr"}
                            >
                              {item.content}
                            </div>
                          )}
                          <CustomerIcon />
                        </div>
                        {!item?.isEditing && (
                          <div className="customerMessage_Tool">
                            <div>
                              <img
                                onClick={() => handleClickEditor(item)}
                                src={EditorIcon}
                              />
                            </div>
                            <div
                              onClick={(e) => {
                                e.stopPropagation();

                                if (
                                  navigator.clipboard &&
                                  navigator.clipboard.writeText
                                ) {
                                  // 现代浏览器 & https/localhost 环境
                                  navigator.clipboard
                                    .writeText(item.content)
                                    .then(() => {
                                      message.success({
                                        content: t("toast.copied"),
                                      });
                                    })
                                    .catch((err) => {
                                      console.error("复制失败:", err);
                                      fallbackCopyText(item.content);
                                    });
                                } else {
                                  // 旧环境 / http 下 fallback
                                  fallbackCopyText(item.content);
                                }
                              }}
                            >
                              <CopyIcon />
                            </div>
                          </div>
                        )}
                      </div>
                    );
                  })}
                  {isLoading &&
                    (() => {
                      const last = chatHistory[chatHistory.length - 1];
                      return (
                        (last?.role === "system" && !last?.content) ||
                        last?.role !== "system"
                      );
                    })() && <div className="loader"></div>}
                </div>
                <div className="ChatDiv_Input">
                  <div className="ChatDiv_Input_mobile">
                    {tipList.map((item) => (
                      <div
                        className="chatInput_button_item"
                        onClick={(e) => {
                          e.stopPropagation();
                          startChat(item.content);
                          // setInputValue("");
                        }}
                        key={item.id}
                      >
                        {item.title}
                      </div>
                    ))}
                  </div>
                  <div className="enterInputDiv chatInputDiv">
                    <div
                      className="enterInputDiv_inputDiv"
                      style={{
                        width: "100%",
                        height: "85%",
                        borderRadius: "8px",
                      }}
                    >
                      <div className="chatInput">
                        <TextArea
                          ref={inputRef}
                          autoSize={{ minRows: 4, maxRows: 4 }}
                          className="chatInput_input"
                          type="text"
                          placeholder={t("input.placeholder")}
                          value={inputValue}
                          onChange={(e) => setInputValue(e.target.value)}
                          onCompositionStart={() => setIsComposing(true)} // 中文输入开始
                          onCompositionEnd={() => setIsComposing(false)} // 中文输入结束
                          onPressEnter={(e) => {
                            if (e.key === "Enter" && !isComposing) {
                              e.preventDefault(); // 阻止默认换行
                              if (inputValue.trim()) {
                                startChat();
                                // setInputValue("");
                              }
                            }
                          }}
                          style={{
                            textAlign:
                              langText === "العربية" ? "right" : "left",
                          }}
                        />
                        <div className="chatInput_button">
                          <div
                            className="enterInputDiv_tips"
                            style={{
                              marginTop: 0,
                              maxWidth: "70%",
                              minWidth: "70%",
                              overflowY: "auto",
                              justifyContent: "flex-start",
                              marginLeft: "11px",
                            }}
                          >
                            {tipList.map((item) => (
                              <div
                                className="chatInput_button_item"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  startChat(item.content);
                                  // setInputValue("");
                                }}
                                key={item.id}
                              >
                                {item.title}
                              </div>
                            ))}
                          </div>
                          <div className="enterInputDivRight">
                            {isListening ? (
                              <img
                                onClick={stopRecognition}
                                className="recordIcon"
                                src={RecordingIcon}
                              />
                            ) : (
                              <img
                                onClick={startRecognition}
                                className="recordIcon"
                                src={RecordIcon}
                              />
                            )}
                            <div className="line"></div>
                            {isLoading ? (
                              <div
                                className="enterInputDiv_button"
                                onClick={pauseChat}
                                style={{
                                  width: "32px",
                                  height: "32px",
                                }}
                              >
                                <img
                                  style={{ width: "32px", height: "32px" }}
                                  src={PauseIcon}
                                />
                              </div>
                            ) : (
                              <div
                                className="enterInputDiv_button"
                                onClick={() => startChat()}
                                style={{
                                  width: "32px",
                                  height: "32px",
                                  // marginRight: "5px",
                                }}
                              >
                                <SendIconSmall />
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>

          <Modal
            mask={false}
            footer={null}
            wrapClassName="shareModalPC"
            open={shareModalOpenPhone}
            onCancel={hideShareModalPhone}
          >
            <div className="shareTitle">
              <i></i>
              {t("cta.share")}
            </div>
            <div className="shareContainer">
              {shareAgentData?.map((itemData) => {
                if (itemData.role === "user") {
                  return (
                    <div
                      className="customerMessage"
                      style={{ marginBottom: "20px" }}
                    >
                      <div className="customerText">{itemData?.content}</div>
                      <CustomerIcon />
                    </div>
                  );
                } else {
                  return (
                    <div className="agentMessage">
                      <div class="agentBg">Pedia</div>
                      <MarkdownContent
                        content={itemData?.content}
                        dir={itemData.language === "ar" ? "rtl" : "ltr"}
                      />
                    </div>
                  );
                }
              })}
            </div>
            <div className="btnDiv">
              <Button
                onClick={handleCopy}
                className="copyBtn"
                icon={<LinkIcon />}
                type="primary"
              >
                {t("cta.copy")}
              </Button>
            </div>
          </Modal>
          {/*删除对话提示弹窗*/}
          <Modal
            style={{ textAlign: langText === "العربية" ? "right" : "left" }}
            wrapClassName="deleteModalPc"
            footer={null}
            title={t("delete.chat.title")}
            open={deleteModal}
            onCancel={handleCloseDelete}
          >
            <p style={{ textAlign: langText === "العربية" ? "right" : "left" }}>
              {t("delete.chat.tips.text")}
            </p>
            <div className="btn">
              <Button onClick={handleCloseDelete}>{t("btn.cancel")}</Button>
              <Button onClick={handleDelete} danger>
                {t("ui.delete")}
              </Button>
            </div>
          </Modal>
        </div>
      )}
    </>
  );
};

export default PC;
